import { Intercom } from 'ng-intercom';
import { UploadFormComponent } from './../uploads/upload-form/upload-form.component';
import { AppLoadedState } from './../app.loaded.state';
import { AppRouterState } from './../app.router.state';
import { GiftSelection } from './../gift/giftSelection';
import { CartService } from './../cart/cart.service';
import { HostListener, AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './registry-firebase.service';
import { ImageUrlService } from '../shared/services/image-url.service';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { DraggableModule } from './../dragndrop/draggable.module';
import { take } from 'rxjs/operators';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  AfterViewChecked
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistryService } from '../registry/registry.service';
import { Gift } from '../gift/gift';
import { GiftComponent } from '../gift/gift.component';
import { HttpService } from '../shared/http.service';
import { UserService } from '../user/user.service';
import { Registry, Section } from '../registry/registry';
import { RegistryModule } from '../registry/registry.module';
import { AnalyticsService } from '../analytics/analytics.service';
import { Subject } from 'rxjs/Subject';
import { fileUploads } from 'stripe';
import { Contribution } from '../track/contribution';
import { DatepickerOptions } from 'ng2-datepicker';
import * as en from 'date-fns/locale/en';
import { Settings } from '../settings/settings';
import { ToastType } from '../toast/toast.enum';
import { SettingsStateStore } from '../settings/settings.state.store';
import { StarterRegistry, TemplateGift } from '../templates/starter-registry';
import { Website } from '../website-builder/wedding';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Merchant } from '../merchant/merchant.state.store';
import { MerchantStateStore } from '../merchant/merchant.state.store';
import {  MerchantState, } from '../shared/machines/merchant.state.machine';
interface Vibe {
  id: string;
  title: string;
  description: string;
  giftCount: number;
  thumbnail: string;
  icon: string;
}

interface Fund {

  name: string;
  thumbnail: string;
  description: string;
}

@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styleUrls: ['./registry.component.scss'],

  // providers: [RegistryFirebaseService]
})
export class RegistryComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @ViewChild(UploadFormComponent) uploader: UploadFormComponent;
  public gifts: Array<Gift> = new Array<Gift>();
  public giftSort: Array<string>
  public soldGifts: Array<Gift> = new Array<Gift>();
  public availableGifts: Array<Gift> = new Array<Gift>();
  movingGiftExistsInSectionName: string;
  movingGiftIsInMyGifts = false;
  public selectedGift: Gift;
  private website: Website;
  debounceTimer: any
  public giftName: string;
  public deleteOption = null;
  public sortedGifts: Array<Gift>;
  public allGifts: Array<Gift> = new Array<Gift>();
  public originalGifts: Array<Gift>;
  public sectionGifts: Array<[string, Array<Gift>]>;
  public isDragingIntoSections = false
  public movingGift: Gift;
  imageCropString: string
  sectionName: string;
  showDeleteSectionPopup = false;
  isAddingNewSection = false;
  imageZoomString: string;
  allGiftsAreGenerated = false;
  public sub: any;
  public scrollPoint = 0;
  isEditingSection = false;
  daysLeft = 24;
  listSelectedCountries: string;
  textColour: string;
  backgroundColour: string;
  contirbutionsLeft: Number;

  submitting = false;
  expectedReturn: Number = 0;
  public daysToGo = 0;
  selectedDestinations: Array<string> = new Array<string>();
  selectionMade = false;

  isAnonymousCouple = false;
  public checkListPercent = 0;
  copyLabel = "Copy";
  hideMobileMenu = false;
  oneOrMoreGiftSelectedForDelete = false;
  public fetched: Boolean;
  public backgroundHeaderImageColor: string;
  public isLoggedIn: Boolean = false;
  public backgroundImage: string;
  public symbol: string;
  public weddingDate: Date;
  public onboardingGiftTypeFund = false;
  public onboardingGiftTypeHoneymoon = false;
  public onboardingVibes = false;
  public settings: Settings;
  hideGuestBanner = false;
  public featuredGift: Gift;
  selectedFilter: string = "everything";
  customDestinations: string[] = [];
  showSampleGiftButton: boolean;
  canSeeLoops = true;
  public password: string;
  public passwordOk = false;
  selectedGiftIsForBulkDelete: Set<string> = new Set();
  public registryName: string;
  closedReferral = false;
  public wrongPassword = false;
  public cardClass = 'small-up-1';
  public textHope = 'In these uncertain times, our love shines the brightest. Whether far or near, we can\'t wait to set off on our adventure of a lifetime together.';
  public textWarm = 'Your presence is present enough, but for those who wish to contribute, please choose a gift from our honeymoon registry.';
  public textModern = 'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
  public textGrateFul = 'Your love, laughter, and company on our big day is the greatest gift of all. However, should you wish to help us celebrate with a gift, please choose from our honeymoon registry.';
  public textHumbled = 'We\'re humbled to have you join us on our special day, and your presence is truly present enough. However, if you feel so obliged to give a gift, please choose from our honeymoon registry.';
  public textFormal = 'As we\'re already lucky enough to have all the physical items we need to start our lives together, we\'ve created a honeymoon registry so we can create new experiences that will last a lifetime.';
  public textPoem = 'If choosing a gift is not your cup of tea, you might like to try our honeymoon registry. Please feel no obligation to use this list, as we do not mind if you decide to give it a miss.';


  //modelChanged: Subject<string> = new Subject<string>();
  preview = false;
  stripeVerify = false;
  giftSelection: GiftSelection;
  regOriginalDate: Date;
  bagSize = 0;
  deleteingFeaturedGfit = false;
  trailDaysRemaining = 14;
  user: User;
  starterRegistries: StarterRegistry[];
  notifications = null;
  loaded = false;
  registryTotal = null;
  editingWelcome = false;
  headerType: string;
  showHeaderImageSelectorModal = false;
  registry: Registry;
  inPreviewMode = false;
  showTranslation = true;
  stopAutoScroll = false;
  private contributions: Contribution[];
  private ngUnsubscribe: Subject<void> = new Subject();
  editDate = false;
  contributionLimit = 0;
  debug = false;
  start = Date.now();
  options: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D, YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,

    barTitleIfEmpty: 'Click to select a date'
    // placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };
  featuredGiftPortionsRemaining: number;
  currentPosition: number;
  hideFeaturedGift: boolean = false;
  sectionDest: string;
  draggingGiftId: string;
  isMovingGiftToSection: boolean;
  previousSectionName: string;
  doNotRefreshGifts: boolean;
  currencySaveButtonEnabled: boolean;
  showCurrencySettings: boolean;
  launched = false;
  showRecAmountModal: boolean;
  onboardRegistryStep: number = 0;
  showRegOnboarding: boolean;
  showDropDown: boolean;
  showGuide: boolean;
  noPaymentMethods: boolean;
  cssLoaded: boolean;
  searchText: string = '';
  isDropdownOpen: boolean = false;
  filteredCountries: string[] = [];
  @ViewChild('searchInput') searchInput: ElementRef;
  destinationCountries: string[];

  // Add this near the top of the file with other properties
  popularDestinations = {
    "AU": ["Bali", "Fiji", "Thailand", "Tokyo"],
    "NZ": ["Bali", "Fiji", "Cook Islands", "Hawaii"],
    "GB": ["Amalfi Coast", "Santorini", "Maldives", "Paris"],
    "US": ["Maui", "Bora Bora", "Italy", "Santorini"],
    "CA": ["Hawaii", "Santorini", "Paris", "Bali"],
    "AT": ["Maldives", "Bali", "Santorini", "Mauritius"],
    "BE": ["Maldives", "Bali", "Santorini", "Seychelles"],
    "DK": ["Maldives", "Bali", "Thailand", "Italy"],
    "FI": ["Maldives", "Bali", "Thailand", "Paris"],
    "FR": ["Maldives", "Bali", "Seychelles", "Mauritius"],
    "DE": ["Maldives", "Bali", "Santorini", "Thailand"],
    "GR": ["Maldives", "Bali", "Paris", "Italy"],
    "IE": ["Maldives", "Bali", "Santorini", "Maui"],
    "IT": ["Maldives", "Bali", "Seychelles", "Thailand"],
    "LV": ["Maldives", "Bali", "Santorini", "Thailand"],
    "LT": ["Maldives", "Bali", "Santorini", "Thailand"],
    "LU": ["Maldives", "Bali", "Santorini", "Seychelles"],
    "NL": ["Maldives", "Bali", "Thailand", "Santorini"],
    "NO": ["Maldives", "Bali", "Thailand", "Amalfi Coast"],
    "PT": ["Maldives", "Bali", "Santorini", "Seychelles"],
    "SK": ["Maldives", "Bali", "Santorini", "Thailand"],
    "SI": ["Maldives", "Bali", "Santorini", "Thailand"],
    "ES": ["Maldives", "Bali", "Santorini", "Mauritius"],
    "SE": ["Maldives", "Bali", "Thailand", "Amalfi Coast"],
    "CH": ["Maldives", "Bali", "Santorini", "Seychelles"],
    "DEFAULT": ["Sydney", "Brisbane"]
  };

  essentialGifts: any[] = [
    {
      "type": "experience",
      "remaining": 1000,
      "paidPercent": 0,
      "pricePerPortion": 0,
      "giftTypeSelection": "Experience",
      "showGiftAmount": null,
      "featuredGift": null,
      "price": 1000,
      "imageUrl": "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb",
      "website": null,
      "description": "After the big day, we'll be jetting away on our adventure of a lifetime.",
      "friendlyUrl": "Flights",
      "status": "active",
      "location": null,
      "title": "Flights",
      "id": "gw8B18dvcDjKSFVCGrNA",
      "hidePrice": false,
      "category": null,
      "videoUrl": null,
      "isAdded": false,
      "toBeAdded": false,
      "addedCount": 0,
      "tags": [],
      "collection": [],
      "points": 0,
      "index": 0,
    }, {
      "id": "1ar16TRP9omce3DfnCZm",
      "price": 250,
      "hidePrice": false,
      "defaultPrice": null,
      "featuredGift": null,
      "location": null,
      "imageUrl": "https://images.pexels.com/videos/6811241/adult-after-bath-bath-bath-rituals-6811241.jpeg",
      "description": "A relaxing couple's spa day to help us unwind on our honeymoon.",
      "giftTypeSelection": "Experience",
      "remaining": 250,
      "category": null,
      "type": "experience",
      "pricePerPortion": 0,
      "videoUrl": "https://player.vimeo.com/external/511906994.sd.mp4?s=7ba0af80476d36869af9c714d2236d61a704f97f&profile_id=164&oauth2_token_id=57447761",
      "paidPercent": 0,
      "showGiftAmount": null,
      "status": "active",
      "website": null,
      "friendlyUrl": "Couples-Spa",
      "title": "Couple's Spa"
    },
    {
      "description": "It's five o'clock somewhere! We'd love you to help us kick off happy hour. Cocktail, anyone?",
      "category": null,
      "remaining": 100,
      "id": "c1pdRB8XR25bn1dL64WN",
      "hidePrice": false,
      "featuredGift": null,
      "paidPercent": 0,
      "website": null,
      "friendlyUrl": "Happy-Hour",
      "giftTypeSelection": "Experience",
      "status": "active",
      "videoUrl": null,
      "imageUrl": "https://images.unsplash.com/photo-1536599424071-0b215a388ba7",
      "price": 100,
      "type": "experience",
      "showGiftAmount": null,
      "title": "Happy Hour",
      "location": null,
      "defaultPrice": null,
      "pricePerPortion": 0
    },
    {
      "website": null,
      "giftTypeSelection": "Experience",
      "price": 200,
      "category": null,
      "videoUrl": "https://player.vimeo.com/external/376145612.sd.mp4?s=b80239282786fa48e250c05808aeef677f675e31&profile_id=165&oauth2_token_id=57447761",
      "featuredGift": null,
      "paidPercent": 0,
      "type": "experience",
      "showGiftAmount": null,
      "remaining": 200,
      "hidePrice": false,
      "id": "LtannIBrXPlQE0Q8W9T3",
      "imageUrl": "https://images.pexels.com/videos/3296402/free-video-3296402.jpg",
      "title": "Romantic Dinner",
      "location": null,
      "pricePerPortion": 0,
      "friendlyUrl": "Romantic-Dinner",
      "description": "A romantic dinner will be the perfect way to celebrate our big day and the love we share for one another.",
      "status": "active",
      "defaultPrice": null
    }, {
      "friendlyUrl": "Accommodation",
      "giftTypeSelection": "Experience",
      "website": null,
      "price": 750,
      "type": "experience",
      "imageUrl": "https://images.unsplash.com/photo-1547110287-71448271b1de",
      "status": "active",
      "id": "9aPc52cuJWRxpfvayORE",
      "featuredGift": null,
      "title": "Airbnb",
      "pricePerPortion": 0,
      "defaultPrice": null,
      "category": null,
      "hidePrice": false,
      "showGiftAmount": null,
      "videoUrl": null,
      "remaining": 750,
      "paidPercent": 0,
      "description": "We'll stay in an Airbnb to live like the locals and soak up the culture of the neighbourhood.",
      "location": null
    }, {
      "giftTypeSelection": "Experience",
      "type": "experience",
      "remaining": 100,
      "featuredGift": null,
      "title": "Breakfast in Bed",
      "pricePerPortion": 0,
      "defaultPrice": null,
      "imageUrl": "https://images.unsplash.com/photo-1549921174-b16174c03ee2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
      "paidPercent": 0,
      "id": "qw3BdE4ufJacmSxCm7y0",
      "price": 100,
      "videoUrl": null,
      "friendlyUrl": "Breakfast-in-Bed",
      "website": null,
      "category": null,
      "description": "What better way to start the day than with a delicious breakfast in bed? Extra shot of coffee, please.",
      "hidePrice": false,
      "showGiftAmount": null,
      "location": null,
      "status": "active"
    }


  ];

  vibes: Vibe[] = [
    {
      id: 'urban-discoverers',
      title: 'Urban Discoverers',
      description: 'Skyline views and cultural marvels.',
      giftCount: 10,
      thumbnail: '/assets/public/images/onb-urban-discoverers.jpg',
      icon: '/assets/public/images/onb-urban-discoverers.svg'
    },
    {
      id: 'tropical-dreamers',
      title: 'Tropical Dreamers',
      description: 'Swaying palms and endless beachside bliss.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-tropical-dreamers.jpg',
      icon: '/assets/public/images/onb-tropical-dreamers.svg'
    },
    {
      id: 'thrill-seekers',
      title: 'Thrill Seekers',
      description: 'From sky-high delight to deep-sea dives.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-thrill-seekers.jpg',
      icon: '/assets/public/images/onb-thrill-seekers.svg'
    },
    {
      id: 'wild-wanderers',
      title: 'Wild Wanderers',
      description: 'Off-grid escapes and nature at its finest.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-wild-wanderers.jpg',
      icon: '/assets/public/images/onb-wild-wanderers.svg'
    },
    {
      id: 'lavish-escapists',
      title: 'Lavish Escapists',
      description: 'Five-star stays and a touch of indulgence.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-lavish-escapists.jpg',
      icon: '/assets/public/images/onb-lavish-escapists.svg'
    },
    {
      id: 'scenic-drifters',
      title: 'Scenic Drifters',
      description: 'Winding roads and breathtaking views.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-scenic-drifters.jpg',
      icon: '/assets/public/images/onb-scenic-drifters.svg'
    },
    {
      id: 'cultural-enthusiasts',
      title: 'Cultural Collectors',
      description: 'Iconic landmarks and immersive experiences.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-cultural-collectors.jpg',
      icon: '/assets/public/images/onb-cultural-collectors.svg'
    },
    {
      id: 'wellness-retreaters',
      title: 'Wellness Retreaters',
      description: 'Serene spas and the art of relaxation.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-zen-finders.jpg',
      icon: '/assets/public/images/onb-zen-finders.svg'
    },
    {
      id: 'foodies',
      title: 'Foodies & Gourmands',
      description: 'World-class flavors worth the journey.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-foodies-and-gourmands.jpg',
      icon: '/assets/public/images/onb-foodies-and-gourmands.svg'
    },
    {
      id: 'eco-conscious',
      title: 'Eco-Conscious Travelers',
      description: 'Sustainable travel that gives back.',
      giftCount: 10,
   thumbnail: '/assets/public/images/onb-eco-conscious.jpg',
      icon: '/assets/public/images/onb-eco-conscious.svg'
    }

  ];
  isDeletingBulkGifts: boolean;
  merchant: Merchant;


  async saveFunds() {
    try {
      this.isCreatingGifts = true;
      this.startLoadingSequence();

      const vibeGifts = await this.getVibes();
      let onboardingFundGifts: Gift[] = [];
      if (vibeGifts['onboarding-funds']) {
        onboardingFundGifts = vibeGifts['onboarding-funds'];
      }

      let fundGiftsToAdd: Gift[] = [];
      for (const fund of this.selectedFunds) {
        let giftToAdd = onboardingFundGifts.find(gift =>
          gift.title.toLowerCase() === fund.toLowerCase()
        );
        if (giftToAdd) {
          let { titleTranslation, descriptionTranslation } = this.extractTranslationFieldsFromTemplateGift(giftToAdd);
          giftToAdd.titleTranslation = titleTranslation;
          giftToAdd.descriptionTranslation = descriptionTranslation;
          fundGiftsToAdd.push(giftToAdd);
        }
      }

      // Create all gifts
      for (const gift of fundGiftsToAdd) {

        const processedGift = {
          ...gift,
          userId: this.settings.userId,
          templateGiftId: null,
          source: null,
          registryId: null,
          id: null,
          showTranslation: this.settings.enableTranslations || false
        };
        await this._registryFirebaseService.addGift(processedGift, this.registry, null, true);
      }
      this.showScrollBar();
      // Wait for 3 seconds

      // Update settings
      
      this.settings.registryEnabled = true;
      this.settings.completedRegistryOnboarding = true;
      await this._settingsStateStore.updateSettings(this.settings);




      const hasGifts = await this.waitForGifts();

      this.showScrollBar();
      // 7. Complete the process
      this.stopLoadingSequence();
      this.isCreatingGifts = false;
      this.router.navigate(['/registry']);
      this.sendCompletedOnboardingAnalyticsEvent();


    } catch (error) {
      console.error('Error saving funds:', error);
      this.stopLoadingSequence();
      this.isCreatingGifts = false;
 
      this.registryService.emitGenericToastMsg("Error creating funds");
    }
  }

  selectAllGifts() {
    for (const gift of this.allGifts) {
      gift.selected = true;
      this.selectedGiftIsForBulkDelete.add(gift.id);
    }
    if (this.featuredGift) {
      this.featuredGift.selected = true;
    }
  }
sendCompletedOnboardingAnalyticsEvent(){

    let giftType = ''
    if (this.onboardingGiftTypeFund) {
      giftType = 'Funds';
    } else if (this.onboardingGiftTypeHoneymoon) {
      giftType = 'Destination gifts';
    } else if (this.onboardingVibes) {
      giftType = 'Vibes';
    }


          this.analyticsService.trackEvent('Registry Onboarding Completed', {   
                  country: this.registry.country,
        currency: this.registry.currency,      
          onboardingGiftTypeHoneymoon: this.onboardingGiftTypeHoneymoon,
          onboardingGiftTypeFund: this.onboardingGiftTypeFund,
          onboardingVibes: this.onboardingVibes,
          onboardingVibesSelected: this.selectedVibes,
          onboardingDestinations: this.customDestinations,
          onboardingFunds: this.selectedFunds    ,
          giftType: giftType

        });

        
        if (this.allGifts && this.allGifts.length > 0){
          this._registryFirebaseService.identifyGiftTotals(this.registry, this.allGifts.length);
        }
}
  deSelectGifts() {
    for (const gift of this.allGifts) {
      gift.selected = false;
    }
    if (this.featuredGift) {
      this.featuredGift.selected = false;
    }
    this.selectedGiftIsForBulkDelete.clear();
  }

  selectedVibes: string[] = [];

  async saveVibes() {

    let numberOfGiftsToWaitFor = 1;
    // Show loading modal
    this.isCreatingGifts = true;
    this.startLoadingSequence();

    try {
      // 1. Get vibe gifts from API
      const vibeGifts = await this.getVibes();

      // 2. Create flat array of gifts from selected vibes
      let allGifts = [];
      this.selectedVibes.forEach(vibeId => {
        if (vibeGifts[vibeId]) {
          allGifts = [...allGifts, ...vibeGifts[vibeId]];
        }
      });

      // 3. Remove duplicates by title
      const uniqueGifts = allGifts.filter((gift, index, self) =>
        index === self.findIndex((g) => g.title === gift.title)
      );

      numberOfGiftsToWaitFor = uniqueGifts.length;

      // 4. Process each gift
      for (const gift of uniqueGifts) {

        
        // 5. Reset specific fields
        let { titleTranslation, descriptionTranslation } = this.extractTranslationFieldsFromTemplateGift(gift);

          const processedGift = {
            ...gift,
            userId: this.settings.userId,
            templateGiftId: null,
            source: null,
            registryId: null,
            id: null,
            showTranslation: this.settings.enableTranslations || false,
            titleTranslation,
            descriptionTranslation
          };

          // 6. Add gift to registry
          await this._registryFirebaseService.addGift(processedGift, this.registry, null, true);
        }


        //wait 2 seconds longer for things to complete


        this.settings.registryEnabled = true;

        this.settings.completedRegistryOnboarding = true;

        await this._settingsStateStore.updateSettings(this.settings);




        //wait until allGifts has at least one gift and when it has at least 1 then redirect to registry
        const hasGifts = await this.waitForGifts(10, numberOfGiftsToWaitFor);
        if (hasGifts) {
          // Update settings and navigate
          this.showRegOnboarding = false;

          this.showScrollBar();
          // 7. Complete the process
          this.stopLoadingSequence();
          this.isCreatingGifts = false;

          await new Promise(resolve => setTimeout(resolve, 2000));
          this.sendCompletedOnboardingAnalyticsEvent();
          this.router.navigate(['/registry']);
        } else {
          console.warn('Gifts not loaded after waiting, navigating anyway');
          this.sendCompletedOnboardingAnalyticsEvent();
          this.router.navigate(['/registry']);
        }

      } catch (error) {
        console.error('Error creating vibe gifts:', error);
        this.stopLoadingSequence();
        this.isCreatingGifts = false;
        this.registryService.emitGenericToastMsg("Error creating gifts");
      }
    }
  private async getVibes() {
    let getVibeUrl = `${environment.firebase.clouldFunctionHost}/getVibeGifts`;
    if (this.settings && this.settings.secondLanguage) {
      getVibeUrl += `?language=${this.settings.secondLanguage.toLowerCase()}`;
    }
      const response = await fetch(getVibeUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch vibe gifts');
      }
      const vibeGifts = await response.json();
      return vibeGifts;
    }

  toggleVibe(vibeId: string) {
    const index = this.selectedVibes.indexOf(vibeId);
    if (index === -1) {
      this.selectedVibes.push(vibeId);
    } else {
      this.selectedVibes.splice(index, 1);
    }
  }

  funds: Fund[] = [
    {  name: 'Honeymoon Fund',
      thumbnail: '/assets/public/images/onb-honeymoon-fund.jpg',
      description: "A dream escape to kick off married life."
     },
    {  name: 'House Fund',
      thumbnail: '/assets/public/images/onb-house-fund.jpg',
      description: "The foundation for your dream home."
    },
    {  name: 'Wedding Fund',
      thumbnail: '/assets/public/images/onb-wedding-fund.jpg',
      description: "Make every moment unforgettable."
    },
    {  name: 'Travel Fund',
      thumbnail: '/assets/public/images/onb-travel-fund.jpg',
      description: "Fuel future adventures together."
    },
    {  name: 'Home Upgrade',
      thumbnail: '/assets/public/images/onb-home-upgrade.jpg',
      description: "Fresh touches to elevate your space."
    },
    { name: 'Baby Fund',
      thumbnail: '/assets/public/images/onb-baby-fund.jpg',
      description: "Your family's perfect beginning."
    },
    {  name: 'Furniture Fund',
      thumbnail: '/assets/public/images/onb-furniture-fund.jpg',
        description: "Style and comfort for every corner."

     },
    {  name: 'Car Fund',
      thumbnail: '/assets/public/images/onb-car-fund.jpg',
      description: "Get the keys to your next adventure."
     },
    {  name: 'Moving Fund',
      thumbnail: '/assets/public/images/onb-moving-fund.jpg',
      description: "Smooth the way to your new beginning."
     },
    {  name: 'Charity Fund',
      thumbnail: '/assets/public/images/onb-charity-fund.jpg',
      description: "Share your joy with causes that matter."
    }
  ];

  selectedFunds: string[] = [];

  toggleFund(fundId: string) {
    const index = this.selectedFunds.indexOf(fundId);
    if (index === -1) {
      this.selectedFunds.push(fundId);
    } else {
      this.selectedFunds.splice(index, 1);
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registryService: RegistryService,
    private httpService: HttpService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _cartService: CartService,
    private _appRouterState: AppRouterState,
    private _appLoadedState: AppLoadedState,
    private cdRef: ChangeDetectorRef,
    private _intercom: Intercom,
    private _settingsStateStore: SettingsStateStore,
    private _websiteStateStore: WebsiteStateStore,
    private _cdr: ChangeDetectorRef,
    private _merchantService: MerchantStateStore,
    private imageUrlService: ImageUrlService
  ) {
    this.debugTimer('constructor')


    this.launched = location.pathname.includes('launched');



    // ;
    //  this.debugTimer("constructor - begin")

    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('starting-off');

    body.style.overflow = 'auto';
    this.copyLabel = "Copy";
    const i = 0 / 0;

    this.bagSize = this._cartService.getCart().cartItems.length;
    // this.route.params.takeUntil(this.ngUnsubscribe).subscribe(val => this.init());
    const cardValue = localStorage.getItem('registry-card-value');

    if (cardValue === 'small-up-2') {
      this.cardClass = 'small-up-2';
    }
    this.debugTimer("constructor - end")

    this.closedReferral = localStorage.getItem('close-referral') != null

    if (localStorage.getItem('showTranslation')) {
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }

  }
  ngAfterViewInit(): void {

    this.checkModalAndHideScrollBar();
  }


  toggleGuide() {
    this.showGuide = !this.showGuide;
    if (this.showGuide == false) {
      localStorage.setItem("seenSetupGuideRegistry", "true");
    }
  }

  checkPaymentMethods() {
    this.noPaymentMethods = false;
    if (!this.registry || !this.settings) {
      return;
    }
    if (!this.registry.hasCustomPaymentMethods && !this.settings.stripeAccountId && (!this.settings.merchantId || (this.merchant && this.merchant.status != MerchantState.KYC_APPROVED))) {
      this.noPaymentMethods = true;
    }
  }

  checkModalAndHideScrollBar() {

    let exists = document.getElementsByClassName('modal-hide-scroll');
    if (exists && exists.length > 0) {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';

    }
  }
  @HostListener('window:scroll', ['$event'])
  onContentScrolled(e: HTMLElement) {

    let scroll = window.scrollY;
    if ((document.documentElement.scrollHeight - 400) <= (scroll + window.innerHeight)) {

      this.hideMobileMenu = true;
      this.currentPosition = scroll;
      return;
    }
    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;

    } else {
      this.hideMobileMenu = false;

    }
    this.currentPosition = scroll;
  }

  toggleShowGiftAmount() {
    this.registry.showGiftAmounts = !this.registry.showGiftAmounts;
    this._registryFirebaseService.saveRegistry(this.registry);

  }

  onboardRegistry(step: number) {
    this.analyticsService.trackEvent('Registry Onboarding Step Clicked', {
      step: step
    });
    if (step == 1) {
      this.settings.registryEnabled = true;
      //this._settingsStateStore.updateSettings(this.settings);
      this.showRegOnboarding = true;
      this.onboardRegistryStep = 1;
    }
    localStorage.setItem("completed_reg_setup", "true");


  }

  parseTempJsonRegData() {
    if ((<any>window).temp_reg) {
      this.registry = (<any>window).temp_reg;

    }
  }
  debugTimer(step) {
    if (!this.debug) {
      return null;
    }
    const millis = Date.now() - this.start;

  }

  openVisibilityLink() {
    return this._registryFirebaseService.openVisibility(this.router, this.registry, this.website);
  }

  dissmissGuestBanner() {
    this.registryService.hideGuestBanner = true;
    this.hideGuestBanner = true;
  }

  goTogiftAssistant() {
    this.router.navigate(['/registry/gift-assistant']);
  }

  viewPlansOrUpgrade() {

    if (!this.registry.paid) {
      this.router.navigate(['/visibility'])
    }
    else if (this.registry.paid && this.registry.tier != 'full') {
      this.router.navigate(['/visibility'])
    }
  }
  toggleDropDown(event: Event) {
    event.stopPropagation();
    this.showDropDown = !this.showDropDown;
  }

  swapElement(array, indexA, indexB) {
    // const tmp = array[indexA];
    // array[indexA] = array[indexB];
    // array[indexB] = tmp;
    array.splice(indexB, 0, array.splice(indexA, 1)[0]);


  }
  enableCurrencySave() {
    if (this.registry.country && this.registry.currency) {
      this.currencySaveButtonEnabled = true;
    }
  }

  removeDuplicateUsingFilter(arr) {
    const unique_array = arr.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });

    return unique_array;
  }
  cancelDeleteFeaturedGift(e: Event) {
    e.stopImmediatePropagation();
    this.deleteingFeaturedGfit = false;
  }

  removeGift(e: Event) {
    e.stopImmediatePropagation();
    localStorage.removeItem('giftSelection');
    // this.analyticsService.trackEvent("delete-gift", this.featuredGift);
    this._registryFirebaseService.removeGift(this.featuredGift, this.registry);
    this.deleteingFeaturedGfit = false;
    this.featuredGift.removingConfirmed = true;
    //this.handleGiftDeleted($)
    this.checkSampleGifts();

  }
  unFeatureGift(featuredGift) {
    this._registryFirebaseService.unfeatureExistinGift([featuredGift]);
    this.populateSectionGifts();
  }

  setTranslation(enabled: boolean) {
    this.showTranslation = enabled;

    if (this.showTranslation) {
      localStorage.setItem('showTranslation', 'true')
    } else {
      if (localStorage.getItem('showTranslation'))
        localStorage.removeItem('showTranslation')
    }
    localStorage.setItem('registry-lang-selected', 'true');
    this.registryService.emitLanguageChange(this.showTranslation);
  }

  changeLang() {

    this.showTranslation = !this.showTranslation;
    if (this.showTranslation) {

      localStorage.setItem('showTranslation', 'true')
    } else {
      if (localStorage.getItem('showTranslation'))
        localStorage.removeItem('showTranslation')
    }
    localStorage.setItem('registry-lang-selected', 'true');
    this.registryService.emitLanguageChange(this.showTranslation);
  }

  openGift(gift: Gift) {


    if (this.isLoggedIn) {

      if (
        gift.paidPercent >= 100 && this.isLoggedIn && this.user && this.user.userId) {
        this.router.navigateByUrl(
          '/registry/' + gift.friendlyUrl.toLowerCase() + "?preview=1&fundedgift=1"
        );
        return;
      }
      this.router.navigate([
        window.location.pathname + '/' + gift.friendlyUrl.toLowerCase() + "/edit"
      ]);


    } else {
      this.router.navigate([
        window.location.pathname + '/' + gift.friendlyUrl.toLowerCase()
      ]);
    }

  }

  addNewSection() {
    this.sectionName = null;
    this.movingGift = null;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.analyticsService.trackEvent('Registry Sections - New Section Popup Opened', {});
    this.isAddingNewSection = true;
    if (!this.registry.sections) {
      this.registry.sections = new Array();
    }


  }

  closeAiGiftsNotification(){
    this.settings.dismissAiGiftsNotification = true;
    this._registryFirebaseService.saveSettings(this.settings);
  }

  async createSectionAndAiGeneratedGiftsForEachDestination(destinationName: string) {
    try {
      // Fetch gifts from the API

      let getUrl = `${environment.firebase.clouldFunctionHost}/getGifts?location=${encodeURIComponent(destinationName)}`;

      if (this.settings.secondLanguage) {
        getUrl += `&language=${encodeURIComponent(this.settings.secondLanguage)}`;
      }

      const idToken: string = await this._authService.authToken().pipe(take(1)).toPromise();
      const requestBody = {
        location: destinationName, // Just include the specific data needed
        language: this.settings.secondLanguage,
        idToken: idToken  // Optional - include if you need language support
      };
      


      const response = await fetch(getUrl, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {

          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch gifts');
      }

      const apiGifts = await response.json();

      // Transform API gifts to match our format
      const transformedGifts = apiGifts.map(gift => {
        // Safely get translations if they exist
        let { titleTranslation, descriptionTranslation } = this.extractTranslationFieldsFromTemplateGift(gift);
        return {
          type: "experience",
          remaining: gift.priceUsd || 0,
          paidPercent: 0,
          titleTranslation,
          descriptionTranslation,
          pricePerPortion: 0,
          giftTypeSelection: "Experience",
          showGiftAmount: null,
          featuredGift: null,
          price: gift.priceUsd || 0,
          // Safely handle imageUrl and parameter removal
          imageUrl: gift.giftImageUrl ? gift.giftImageUrl.split('?')[0] : undefined,
          website: null,
          description: gift.giftDescription || '',
          // Safely handle title for friendlyUrl
          friendlyUrl: (gift.giftName || '').replace(/\s+/g, '-'),
          status: "active",
          location: null,
          title: gift.giftName || '',
          hidePrice: !gift.priceUsd,
          category: null,
          videoUrl: null,
          templateGiftId: null,
          giftImageUrls: gift.giftImageUrls
        };
      });

      // Create section with gifts
      await this._registryFirebaseService.createSectionWithGifts(destinationName, transformedGifts, true);

      return transformedGifts.length;

    } catch (error) {
      console.error('Error creating gifts for destination:', destinationName, error);
      return 0;
    }
  }



  private extractTranslationFieldsFromTemplateGift(gift: any) {
    const translations = gift.translations || {};
    if(!this.settings.secondLanguage){
      return {titleTranslation: null, descriptionTranslation: null};
    }
    const secondLanguage = this.settings.secondLanguage.toLowerCase();

    // Get translated title and description only if both translations and language exist
    // Get translated title and description only if both translations and language exist
    let titleTranslation;
    let descriptionTranslation;

    if (secondLanguage &&
      translations &&
      translations[secondLanguage] &&
      translations[secondLanguage].giftName) {
      titleTranslation = translations[secondLanguage].giftName;
    }

    if (secondLanguage &&
      translations &&
      translations[secondLanguage] &&
      translations[secondLanguage].giftDescription) {
      descriptionTranslation = translations[secondLanguage].giftDescription;
    }
    return { titleTranslation, descriptionTranslation };
  }

  createSectionAndGiftsForEachDestination(destinationName: string) {
    let giftsForDestination = this.starterRegistries.filter(x => x.country == destinationName)[0].gifts;
    if (giftsForDestination.length > 11) {
      giftsForDestination = giftsForDestination.slice(0, 11);
    }
    this._registryFirebaseService.createSectionWithGifts(destinationName, giftsForDestination);

    return giftsForDestination.length;
  }


  createHoneymoonEssentialsSection(gifts: TemplateGift[]): Promise<number> {
    this._registryFirebaseService.createSectionWithGifts('Honeymoon Essentials', gifts);
    return Promise.resolve(gifts.length);
  }


  async saveCountries() {


    if (!this.customDestinations || this.customDestinations.length === 0) {
      this.skipDestinations();
      this.showScrollBar();
      return;
    }

    try {
      // Start loading sequence
      let numberOfGiftsToWaitFor = 1;
      // Show loading modal
      this.isCreatingGifts = true;
      this.startLoadingSequence();

      this.selectedDestinations = this.customDestinations.filter(destination =>
        this.starterRegistries.some(registry =>
          registry.country.toLowerCase() === destination.toLowerCase()
        )
      );


      //remove selectedDestinations from customDestinations
      // this.customDestinations = this.customDestinations.filter(destination =>
      //   !this.selectedDestinations.includes(destination)
      // );

      const vibeGifts = await this.getVibes();
      let honeymoonEssentials: TemplateGift[] = [];
      if (vibeGifts['honeymoon-essentials']) {
        honeymoonEssentials = vibeGifts['honeymoon-essentials'];

        honeymoonEssentials.forEach(gift => {
          let { titleTranslation, descriptionTranslation } = this.extractTranslationFieldsFromTemplateGift(gift);
          gift.titleTranslation = titleTranslation;
          gift.descriptionTranslation = descriptionTranslation;
        });
      }
      

      numberOfGiftsToWaitFor =
        (this.selectedDestinations.length * 8 )


      // Create gifts for each destination
      const results = await Promise.all([
        // Single promise for honeymoon essentials
        this.createHoneymoonEssentialsSection(honeymoonEssentials),
        
        // Promise that resolves when all destination promises resolve
        Promise.all(this.customDestinations.map(destination =>
          this.createSectionAndAiGeneratedGiftsForEachDestination(destination)
        ))
      ]);
      
      //make sure registry.sections that one called 'Honeymoon Essentials' is last
      let honeymoonEssentialsSection = this.registry.sections.find(section => section.name === 'Honeymoon Essentials');
      if (honeymoonEssentialsSection) {
        this.registry.sections.splice(this.registry.sections.indexOf(honeymoonEssentialsSection), 1);
        this.registry.sections.push(honeymoonEssentialsSection);
      }


      this._registryFirebaseService.saveRegistry(this.registry);
      //giftsCreated = results[0].reduce((sum, count) => sum + count, 0);

      // Format destination string
      let destinationString = '';
      if (this.selectedDestinations.length > 1) {
        if (this.selectedDestinations.length === 2) {
          destinationString = this.selectedDestinations.join(' and ');
        } else {
          const lastDestination = this.selectedDestinations[this.selectedDestinations.length - 1];
          destinationString = this.selectedDestinations.slice(0, -1).join(', ') + ', and ' + lastDestination;
        }
      } else {
        destinationString = this.selectedDestinations[0];
      }

      // Update settings

      this.settings.registryEnabled = true;
      this.settings.completedRegistryOnboarding = true;
      await this._settingsStateStore.updateSettings(this.settings);

 
      this.sendCompletedOnboardingAnalyticsEvent();
      console.log('numberOfGiftsToWaitFor', numberOfGiftsToWaitFor);
      // Wait for gifts to be loaded
      const hasGifts = await this.waitForGifts(30, numberOfGiftsToWaitFor);

      this.showRegOnboarding = false;
      // Cleanup and navigate
      this.stopLoadingSequence();
      this.isCreatingGifts = false;
      this.showScrollBar();
      this.router.navigate(['/registry']);

    } catch (error) {
      console.error('Error creating gifts:', error);
      this.stopLoadingSequence();
      this.isCreatingGifts = false;
      this.registryService.emitGenericToastMsg("Error creating gifts");
      this.showScrollBar();
    }
  }

  showScrollBar() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }
  hideScrollBar() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }
  skipDestinations() {
    this.settings.registryEnabled = true;
    let dismissRegSetupPopup = localStorage.setItem("dismiss_reg_setup", "true");
    this.showRegOnboarding = false;
    this.settings.completedRegistryOnboarding = true;

    this._settingsStateStore.updateSettings(this.settings);
  }
  saveRegistry() {
    this._registryFirebaseService.saveRegistry(this.registry);
    this.showCurrencySettings = false;
    this.showRecAmountModal = false;
  }


  moveSectionUp(sectionName: string) {
    const sectionIndex = this.registry.sections.findIndex(section => section.name === sectionName);
    this.analyticsService.trackEvent('Registry Sections - Section Moved Up', { section: sectionName });
    this.analyticsService.trackEvent('Registry Show Add New Section Popup', {});
    if (sectionIndex > 0) {
      const sectionToMove = this.registry.sections.splice(sectionIndex, 1)[0];
      this.registry.sections.splice(sectionIndex - 1, 0, sectionToMove);
      this._registryFirebaseService.saveRegistry(this.registry).then(() => {
        this.populateSectionGifts();
      });
    }
  }

  goToSlide2() {
    this.onboardRegistryStep = 2;
    this.analyticsService.trackEvent('Registry Onboarding Slide Clicked', {
      slide: 2,
      country: this.registry.country,
      currency: this.registry.currency
    });
    this._registryFirebaseService.saveRegistry(this.registry);
  }
  gotToSlide3() {
    if (this.onboardingGiftTypeHoneymoon || this.onboardingGiftTypeFund || this.onboardingVibes) {

          let giftType = ''
    if (this.onboardingGiftTypeFund) {
      giftType = 'Funds';
    } else if (this.onboardingGiftTypeHoneymoon) {
      giftType = 'Destination gifts';
    } else if (this.onboardingVibes) {
      giftType = 'Vibes';
    }


      this.onboardRegistryStep = 3;

      this.analyticsService.trackEvent('Registry Onboarding Slide Clicked', {
        slide: 3,
        giftType: giftType,
        country: this.registry.country,
        currency: this.registry.currency,
        onboardingGiftTypeHoneymoon: this.onboardingGiftTypeHoneymoon,
        onboardingGiftTypeFund: this.onboardingGiftTypeFund,
        onboardingVibes: this.onboardingVibes
      });
    } else {
      let description = "We're trading toasters for tickets and tradition for adventure. Your gift won't just fund a trip — it'll help us kick off our new life together with unforgettable memories.";
      let title = "Honeymoon Fund";

      // Add translations if enabled
      let descriptionTranslation = null;
      let registryIntroTranslation = null;
      let titleTranslation = null;
      if (this.settings && this.settings.enableTranslations && this.settings.secondLanguage) {
        const lang = this.settings.secondLanguage.toLowerCase();
        const translations = require(`../translator/languages/${lang}.json`);
        descriptionTranslation = translations[description] || null;
        titleTranslation = translations[title] || null;
        registryIntroTranslation = translations[this.registry.introductionText] || null;


      }



      let newGift: any = {
        "descriptionTranslation": descriptionTranslation,
        "description": description,
        "templateGiftId": "achCofAc7bxidJv4CkFH",
        "type": "fund",
        "pricePerPortion": 0,
        "title": title,
        "titleTranslation": titleTranslation,
        "createdFromGiftAssistant": null,
        "showGiftAmount": false,
        "videoUrl": null,
        "price": 99999,
        "fromRegistry": "search-results",
        "giftTypeSelection": "Experience",
        "portions": null,
        "editedAfterGiftAssistant": null,
        "website": null,
        "hidePrice": true,
        "fromTemplate": true,
        "remaining": 99999,
        "createdDate": 1697249444792,
        "paidPercent": 0,
        "modifiedDate": 1697249444792,
        "featuredGift": true,
        "category": null,
        "friendlyUrl": "Honeymoon-Fund",
        "status": "active",
        "imageUrl": "https://images.unsplash.com/photo-1544298903-35eee5a95b4d",
        "hex": "#0c5973",
        userId: this.settings.userId,
        "showTranslation": this.settings.enableTranslations || false
      }
      if (newGift.showTranslation == undefined) {
        newGift.showTranslation = null;
      }
      if (this.settings && this.settings.enableTranslations && this.settings.secondLanguage) {
        this.registry.introductionTextTranslation = registryIntroTranslation;
      }

      this._registryFirebaseService.addGift(newGift as Gift, this.registry, null, true).then(() => {
        this._registryFirebaseService.saveRegistry(this.registry);
        this.settings.completedRegistryOnboarding = true;
        this._settingsStateStore.updateSettings(this.settings);
        this.showScrollBar();
      })
    }


  }


  goToSlide(step: number) {
    this.onboardRegistryStep = step;
    this.analyticsService.trackEvent('Registry Onboarding Slide Clicked', {
      slide: step
    });

  }
  moveSectionDown(sectionName: string) {
    this.analyticsService.trackEvent('Registry Sections - Section Moved Down', { section: sectionName });
    const sectionIndex = this.registry.sections.findIndex(section => section.name === sectionName);
    if (sectionIndex !== -1 && sectionIndex < this.registry.sections.length - 1) {
      const sectionToMove = this.registry.sections.splice(sectionIndex, 1)[0];
      this.registry.sections.splice(sectionIndex + 1, 0, sectionToMove);
      this._registryFirebaseService.saveRegistry(this.registry).then(() => {
        this.populateSectionGifts();
      });

    }
  }
  editingSectionName(sectionName: string) {
    this.analyticsService.trackEvent('Registry Sections - Section Named Edit Open', { section: sectionName });
    this.sectionName = sectionName;
    this.previousSectionName = sectionName;
    this.isAddingNewSection = true;
    this.isEditingSection = true;
  }
  closeAddNewSection() {

    this.isAddingNewSection = false;
    this.isEditingSection = false;
    this.previousSectionName = null;
    this.sectionName = null;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }
  closeDeleteSection() {
    this.showDeleteSectionPopup = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

  }

  deleteSection(sectionName: string, gifttIds: string[]) {

    if (!gifttIds || gifttIds.length == 0) {
      let index = this.registry.sections.findIndex(x => x.name == sectionName);
      if (index > -1) {
        this.registry.sections.splice(index, 1);
      }
      this.sectionGifts = this.sectionGifts.filter(tuple => tuple[0] !== sectionName);
      this._registryFirebaseService.saveRegistry(this.registry)
      this.analyticsService.trackEvent('Registry Sections - Section Deleted', { section: sectionName });
      this.populateSectionGifts();


    }
    else {
      this.deleteOption = 'keep';
      this.sectionName = sectionName;
      this.showDeleteSectionPopup = true;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
      // let sectionIndex = this.registry.sections.findIndex(section => section.name === sectionName);
      // if (sectionIndex > -1) {
      //   let gifts = this.registry.sections[sectionIndex].gifts;

      //   gifts.filter(gift => {
      //     return !gifttIds.includes(gift.id);
      //   });

      //   if(gifts.length == 0){
      //     this.registry.sections.splice(sectionIndex, 1);
      //   }
      //   else{
      //     this.registry.sections[sectionIndex].gifts = gifts;
      //   }
      // }
    }
    // this.registry.sections = this.registry.sections.filter(section => section.name !== sectionName);

    // this._registryFirebaseService.saveRegistry(this.registry).then(() => {
    //   this.populateSectionGifts();
    // });

  }

  addSection() {
    let newSection = new Section();
    newSection.name = this.sectionName;
    if (this.previousSectionName && this.isEditingSection) {
      let index = this.registry.sections.findIndex(x => x.name == this.previousSectionName);
      this.registry.sections[index].name = this.sectionName;
      this.analyticsService.trackEvent('Registry Sections - Section Updated', { previewsName: this.previousSectionName, newName: this.sectionName });
    }
    else {

      if (!this.registry.sections) {
        this.registry.sections = new Array();
      }

      if (this.registry.sections && this.registry.sections
        .findIndex(x => x.name === this.sectionName) == -1) {
        this.registry.sections.unshift(newSection);
      }
      if (this.movingGift) {

        this.moveGiftToSection(this.movingGift.id, this.sectionName);
      }

    }


    this._registryFirebaseService.saveRegistry(this.registry).then(() => {

    })
    this.closeAddNewSection();
    this.populateSectionGifts();

  }

  closeMovingGift() {
    this.isMovingGiftToSection = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }
  filterGifts() {
    this.hideFeaturedGift = false;

    if (this.selectedFilter === 'needed') {
      this.gifts = this.sortedGifts.filter(x => x.status === 'active');

      if (this.featuredGift && this.featuredGift.status !== 'active') {
        this.hideFeaturedGift = true;
      }

      this.populateSectionGifts('active');


    } else if (this.selectedFilter === 'funded') {
      this.gifts = this.sortedGifts.filter(x => x.status === 'paid');

      if (this.featuredGift && this.featuredGift.status !== 'paid') {
        this.hideFeaturedGift = true;
      }
      this.populateSectionGifts('paid');
    } else {
      this.gifts = this.sortedGifts;
      this.populateSectionGifts();
    }
  }

  onDragEnd(event: DragEvent) {
    const destinationElement = event.currentTarget as HTMLElement;
    const destinationId = destinationElement.id;

    ;
    let destName: string = (event.target as any).id;

    let destSectionIndex = this.registry.sections.findIndex(section => section.name === destName);
    let movedGiftSection = this.registry.sections[destSectionIndex];

    if (movedGiftSection && !movedGiftSection.giftIds) {
      movedGiftSection.giftIds = new Array();
    }

    //movedGiftSection.giftIds.push
    // movedGiftSection.gifts.splice(movedGiftSection.gifts.indexOf(movedGift), 1);
    // this.registry.sections[destSectionIndex].gifts.push(movedGift);
    ;
    const data = event.dataTransfer.getData('text/plain');


    const sourceElement = document.getElementById(data!);
    let test = event.dataTransfer.getData('text/plain');


    this.isDragingIntoSections = false;
  }
  onDragStart(event: any) {

    const sourceElement = event.target as HTMLElement;
    this.draggingGiftId = sourceElement.id;
    //  event.dataTransfer?.setData('text/plain', sourceElement.id);

    this.isDragingIntoSections = true;
    this.cdRef.detectChanges();

    event.dataTransfer.setData('text/plain', event.target.id);
  }

  isFirstSection(sectionName: string): boolean {
    if (this.registry && this.registry.sections && this.registry.sections.length > 0) {
      return this.registry.sections[0].name === sectionName;
    }

  }

  isLastSection(sectionName: string): boolean {

    if (this.registry && this.registry.sections && this.registry.sections.length > 0) {
      const lastIndex = this.registry.sections.length - 1;
      return this.registry.sections[lastIndex].name === sectionName;
    }
  }

  onDragOver(event: DragEvent) {

    let sectionDestination = null;
    let dest: string = (event.currentTarget as any).id
    if (dest) {
      dest = dest.replace("div#", '')
      this.sectionDest = dest;
      this.isDragingIntoSections = false;
    }
    event.preventDefault();
  }

  onDrop(event: DragEvent) {

    event.preventDefault();
    this.isDragingIntoSections = false;


    let giftId = (event.target as any).id


    this.moveGiftToSection(this.draggingGiftId, this.sectionDest)
  }

  deleteSectionAndGifts(deleteOption: string) {
    this.deleteOption = deleteOption;
    this.registry.sections = this.registry.sections.filter(section => section.name !== this.sectionName);


    this._registryFirebaseService.saveRegistry(this.registry);

    if (deleteOption == "delete") {

      let test = this.sectionGifts.filter(section => section[0] == this.sectionName)[0];
      test[1].forEach(gift => {

        this._registryFirebaseService.removeGift(gift, this.registry);
      });
      // .forEach(section => {
      //   section[1].forEach(gift => {

      //     this._registryFirebaseService.removeGift(gift, this.registry);
      //   });


    }
    this.sectionGifts = this.sectionGifts.filter(tuple => tuple[0] !== this.sectionName);
    this.loadGifts(this.originalGifts);

    this.closeDeleteSection();

  }
  checkIfGiftIdExistsInSection(giftId: string, sectionName: string): boolean {
    let section = this.registry.sections.find(x => x.name == sectionName);
    if (!section || !section.giftIds || section.giftIds.length == 0) return false;
    if (section.giftIds.includes(giftId)) {
      return true;
    } else {
      return false
    }

  }

  checkIfGiftIdExistsInOtherSection(giftId: string) {
    let giftExistsInSection = false;
    if (!this.registry.sections || this.registry.sections.length == 0) { return }

    this.registry.sections.forEach(section => {
      if (section.giftIds && section.giftIds.length > 0) {
        if (section.giftIds.includes(giftId)) {
          // section.giftIds = section.giftIds.filter(giftId => giftId !== giftId)
          giftExistsInSection = true;

        }
      }
    })
    return giftExistsInSection;
  }

  moveGiftToSection(giftId: string, sectionName: string) {

    if (!this.registry.sections || this.registry.sections.length == 0) { return }


    this.registry.sections.forEach(section => {
      if (section.giftIds && section.giftIds.length > 0) {
        if (section.giftIds.includes(giftId)) {

          section.giftIds = section.giftIds.filter(x => x !== giftId)


        }
      }
    })

    if (sectionName) {



      let sectionIndex = this.registry.sections.findIndex(section => section.name === sectionName)
      if (sectionIndex >= 0) {

        if (!this.registry.sections[sectionIndex].giftIds || this.registry.sections[sectionIndex].giftIds.length == 0) {
          this.registry.sections[sectionIndex].giftIds = [];
        }
        this.analyticsService.trackEvent('Registry Sections - Gift Moved Into Section', { giftId: giftId, section: sectionName });
        this.registry.sections[sectionIndex].giftIds.push(giftId);
      }

    } else {
      this.loadGifts(this.originalGifts)
    }
    this._registryFirebaseService.saveRegistry(this.registry);

    this.isMovingGiftToSection = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.checkModalAndHideScrollBar();
    this.loadGifts(this.originalGifts)
    //this.populateSectionGifts();



  }

  debounceAndSaveRegistry(registry: Registry) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this._registryFirebaseService.saveRegistry(registry);
    }, 500);
  }

  onSortToSection($event, sectionName) {
    let oldContainer = $event.oldContainer;
    let newContainer = $event.newContainer;
    if (oldContainer != newContainer) {
      return;
    }
    let section: Section = this.registry.sections.find(section => section.name === sectionName);

    let movedGift = (this.gifts[$event.oldIndex])
    let movedToGift = (this.gifts[$event.newIndex])
    this.swapElement(section.giftIds, $event.oldIndex, $event.newIndex);
    let currentSection = this.sectionGifts.filter(tuple => tuple[0] === sectionName)[0];
    this.swapElement(currentSection[1], $event.oldIndex, $event.newIndex);
    this.doNotRefreshGifts = true;
    this.populateSectionGifts();

    this._registryFirebaseService.saveRegistry(this.registry).then(x => {
      this.doNotRefreshGifts = false;
    });

  }

  updateSortingInSection() {

  }

  onSort($event) {


    let movedGift = (this.gifts[$event.oldIndex])
    let movedToGift = (this.gifts[$event.newIndex])
    let oldContainer = $event.oldContainer.id;
    let newContainer = $event.newContainer.id;
    if (movedGift.status == 'paid' || movedToGift.status == 'paid') {
      return;
    }
    this.swapElement(this.gifts, $event.oldIndex, $event.newIndex);
    this.registry.giftSort = this.removeDuplicateUsingFilter(
      this.gifts.map(x => x.id)

    );
    this.sortedGifts = this.gifts;
    this._registryFirebaseService.saveRegistry(this.registry).then(x => {

    });
  }
  toggleClass(className: string) {
    localStorage.setItem('registry-card-value', className);
    this.cardClass = className;
  }
  toggleHideIntoTitle() {

    this.registry.hideIntroTitle = !this.registry.hideIntroTitle;
    this._registryFirebaseService.updateReg(this.registry
    );
  }

  updateReg() {
    this._registryFirebaseService.updateReg(this.registry);
    this.editingWelcome = false;
  }

  toggleHideIntroText() {
    this._registryFirebaseService.updateHideRegistryIntroText(
      this.user,
      this.registry.id,
      !this.registry.hideIntroText
    );
  }



  launchClick() {
    // if (!this.registry.paid && (!this.registry.hasCustomPaymentMethods)) {
    //   this.router.navigate(['/registry/add-payment-methods']);
    // } else if (!this.registry.paid && (this.registry.hasCustomPaymentMethods)) {
    //   this.router.navigate(['/visibility']);
    // } else {
    //   this.router.navigate(['/registry/publish/step-3']);
    // }
    this._registryFirebaseService.showMiniLaunchPopup(true, false);
  }

  showToTop() {
    return window.scrollY > 350;
  }
  ngAfterViewChecked(): void {
    // this.uploader.imageObsvervable
    //   .pipe(
    //     startWith(null),
    //     delay(0),
    //     tap(() => this.handle
    //   ).subscribe();

    this.debugTimer("ngAfterViewChecked - begin")
    // if (this.stopAutoScroll) {
    //   return;
    // }


    if (
      this.registryService &&
      this.registryService.giftSelection &&
      this.registryService.giftSelection.gift
    ) {
      const giftElement = document.getElementById(
        this.registryService.giftSelection.gift.id
      );
      if (giftElement) {
        //
        this.registryService.setGiftSelection(new GiftSelection());

        const scrollPoint = this.registryService.getScrollY();
        ;
        if (scrollPoint > 0) {
          window.scrollTo(0, scrollPoint);
        }
      }
    }
    this.checkModalAndHideScrollBar();
    this.debugTimer("ngAfterViewChecked - begin")
  }

  CheckPassword() {
    this.wrongPassword = false;
    localStorage.removeItem('p2');
    if (this.password === this.registry.password) {
      this.passwordOk = true;
      this.registryService.passwordOk = true;
      localStorage.setItem('p2', this.password);
    } else {
      this.wrongPassword = true;
    }
  }

  checkPreviousPW() {
    if (this.registry && this.registry.password) {
      let olPW = localStorage.getItem('p2');
      if (olPW === this.registry.password) {
        this.passwordOk = true;
        this.registryService.passwordOk = true;
      }
    }
  }


  openUploader() {
    this.editingWelcome = false;
    document.getElementById('file_input_idprofile').click();
  }

  clearProfilePic() {
    this._registryFirebaseService
      .updateRegistryProfilePic(this.user, this.registry.id, null)
      .then(registry => {
        this.registry.profileImageUrl = null;

        if (registry) {
          // this.registry = registry;
        }
      });
  }

  setDate() {
    if (this.weddingDate !== this.regOriginalDate) {

      this._registryFirebaseService
        .updateWeddingDate(
          this.user,
          this.registry.id,
          this.weddingDate.getDate(),
          this.weddingDate.getMonth() + 1,
          this.weddingDate.getFullYear()

        )
        .then(() => {
          this.regOriginalDate = this.weddingDate;
          this.editDate = false;
          this.calcDateDiff();

        });
    }
  }

  removePhoto() {
    this.registry.profileImageUrl = null;

    this._registryFirebaseService.updateRegistryProfilePic(
      this.user,
      this.registry.id,
      null
    );
  }

  handledUploadedImageProfile(event: string) {
    if (event && event.endsWith('&mode=profile')) {
      event = event.replace('&mode=profile', '');
      event = event + '?hex=ffffff';

      this._registryFirebaseService
        .updateRegistryProfilePic(this.user, this.registry.id, event)
        .then(registry => {
          this.registry.profileImageUrl = event;

          if (registry) {
            // this.registry = registry;
          }
          this.analyticsService.trackEvent('Uploaded profile photo', { photo: event });
        });
    }
  }

  calculatePercent() {
    this.checkListPercent = 0;
    if (!this.registry) {
      return 0;
    }
    if (this.registry.hasUpdatedRegistry) {
      this.checkListPercent = this.checkListPercent + 0;
    } else if (!this.registry.hasUpdatedRegistry && this.registry.isLive) {
      this.registry.hasUpdatedRegistry = true;
      this.checkListPercent = this.checkListPercent + 0;
    }

    if (this.registry.hasCreatedOrEditedGifts) {
      this.checkListPercent = this.checkListPercent + 0;
    } else if (!this.allGiftsAreGenerated && this.gifts && this.gifts.length > 0) {
      this.checkListPercent = this.checkListPercent + 0;
      this.registry.hasCreatedOrEditedGifts = true;
    }



    if (this.registry.isLive) {
      this.checkListPercent = this.checkListPercent + 0;
    }

  }

  focusToGifts() {
    document.getElementById('gifts').scrollIntoView();
  }

  previewUrl() {

    this.registry.registryName + '?preview=1';
  }
  goToPreview(url) {
    window.open(this.registry.registryName + '?preview=1');
  }
  goToDestinations() {

    this.router.navigateByUrl("/registry/templates/destinations")

  }

  goToTemplates(sectionName: string = null) {
    if (sectionName) {
      this.router.navigateByUrl("/registry/templates/" + sectionName)
    } else {
      this.router.navigateByUrl("/registry/templates")
    }
  }

  initRegistryData() {
    this.defaultTextColor();
    this.configurePassword();
    this.cleanBackgroundImageUrl()
    this.processImageBackgroundPosition(this.registry)
  }


  ngOnInit() {

    let ollieTestMode = false;
    if(ollieTestMode){
     this.isCreatingGifts = true;
    } else {
      this.isCreatingGifts = false;
    }

    //if registry-lang-selected exists delete it


    this.showGuide = true;
    let seenGuide = localStorage.getItem("seenSetupGuideRegistry")
    if (seenGuide) {
      this.showGuide = false;
    }


    this._settingsStateStore.getState().subscribe(state => {
      this.settings = state.settings;
    });
    this.debugTimer('oninit start')


    if (this.router.url === '/setup') {

      this.loaded = false;
      return;
    }

    const destinationGifts = require('../templates/destination-gifts.json');
    let starterRegistryString = localStorage.getItem('starter-registries');

    if (!starterRegistryString) {
      this.starterRegistries = destinationGifts;
    } else {

      this.starterRegistries = JSON.parse(starterRegistryString);
    }


    if (this.starterRegistries && this.starterRegistries.length > 0) {
      this.starterRegistries.forEach(reg => {
        reg.countryFlagImageUrl = this.getImageUrl(reg.country);
      })

      this.destinationCountries = this.starterRegistries.map(reg => reg.country);
      this.removeStarterRegistriesThatHaveZeroGifts();
      this.sortStarterRegistriesAlphabeticallyByCountryName();
    }



    // this._registryFirebaseService.killLoader();
    // if (localStorage.getItem('tempReg')) {
    //   (window as any).temp_reg = localStorage.getItem('tempReg');
    // }
    // if ((window as any).temp_reg) {

    //   this.registry = (window as any).temp_reg;
    //   this.defaultTextColor();
    //   this.processImageBackgroundPosition(this.registry)
    //   this.configurePassword();


    // }
    this.debugTimer('oninit - temp storage finished')

    this.init();

    let langSelected = localStorage.getItem('registry-lang-selected');
    if (!this.isLoggedIn && this.registry) {

      this._merchantService.getMerchant(this.registry.userId).subscribe(merchant => {
        this.merchant= merchant;
      });

      this._settingsStateStore.getSettingsViaUserId(this.registry.userId).subscribe(settings => {
        this.settings = settings;

        if (this.settings && this.settings.enableTranslations && this.settings.defaultLanguage != 'English' && !localStorage.getItem('registry-lang-selected')) {
          this.setTranslation(true);

        } else {
          //this.setTranslation( false);
        }
      });
    }
    this.registryService.getStarterRegistryTemplates();
    this.registryService.getGiftTemplates();

    if (location.search.includes('translate')) {
      this.setTranslation(true);

    }
    this.route.fragment.subscribe(fragment => {

      this.closeAddNewSection();
      if (fragment == 'intro') {
        this.openPopup('couple/reg-intro')
      } else if (fragment == 'cover') {
        this.showPopup();
      } else if (fragment == 'collections') {
        this.addNewSection();
      }
    });
    this.checkCssLoaded();

    // Add this to your existing subscriptions
    this._registryFirebaseService.moveGiftToSection$.subscribe(gift => {
      // Handle the gift being moved to a section
  this.handleMoveModalEvent(gift);
    });
  }

  getImageUrl(country: string) {
    country = country.toLowerCase();
    country = country.replace(" ", "")
    return "/assets/public/images/flags/" + country + ".svg"

  }
  toggleSelect(destination: string, event?: Event, fromPopularButton: boolean = false) {
    
    if (event) {
      event.stopPropagation();
    }

    if (this.selectedDestinations.includes(destination)) {
      this.selectedDestinations.splice(this.selectedDestinations.indexOf(destination), 1);
      this.customDestinations.splice(this.customDestinations.indexOf(destination), 1);
    } else {
      this.selectedDestinations.push(destination);
      this.customDestinations.push(destination);
      if(fromPopularButton){
        this.analyticsService.trackEvent('Registry Onboarding - Destinations - Add Destination', { destination: destination, from:'popular-button' });
      }
    }
    this.collaceSelectedCountries();
    ;
    this.isDropdownOpen = false;
    console.log("isDropdownOpen", this.isDropdownOpen)
    this.searchText = '';
    if(this.cdRef){
      this.cdRef.detectChanges();
    }
  }
  collaceSelectedCountries() {
    this.listSelectedCountries = "";
    this.selectedDestinations.forEach(destination => {
      if (!this.listSelectedCountries) {
        this.listSelectedCountries = destination
      } else {
        this.listSelectedCountries += ", " + destination;
      }
    });
  }


  sortStarterRegistriesAlphabeticallyByCountryName() {
    if (!this.starterRegistries || this.starterRegistries.length == 0) {
      return
    }
    this.starterRegistries.sort((a, b) => {
      if (a.country < b.country) { return -1; }
      if (a.country > b.country) { return 1; }
      return 0;
    })
  }
  removeStarterRegistriesThatHaveZeroGifts() {
    if (!this.starterRegistries || this.starterRegistries.length == 0) {
      return
    }

    this.starterRegistries = this.starterRegistries.filter(registry => {
      return registry.gifts.length > 0
    })
  }

  ngOnDestroy() {
    this.stopLoadingSequence();
    this.cdRef.detach(); // try this
    this.userService.emitUpdateHeaderType('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  saveRegistryText(removeText: boolean) {
    if (removeText) {
      this.registry.introductionText = '';
    } else {
      this._registryFirebaseService.saveRegistry(this.registry);
      this.analyticsService.trackEvent('Updated registry intro text', this.registry.introductionText);
      this.editingWelcome = false;
    }
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 2;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 16); // 20px = line-height: 1.25rem
  }
  saveSettings() {
    this._settingsStateStore.updateSettings(this.settings);
  }

  goToSettings() {
    window.scroll(0, 0);
    this.router.navigate(['/registry/settings']);
  }

  calcDateDiff() {
    if (!this.weddingDate) {
      return;
    }

    const now = new Date();

    const ticksDiff = this.weddingDate.getTime() - new Date().getTime();
    if (ticksDiff > 0) {
      const diffTime = Math.abs(ticksDiff);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      this.daysToGo = diffDays;
    } else {
      this.daysToGo = -1;
    }

  }
  loadDates(registry: Registry) {

    if (registry.weddingDay && registry.weddingMonth && registry.weddingYear) {
      this.weddingDate = new Date(
        registry.weddingYear,
        registry.weddingMonth - 1,
        registry.weddingDay,
        0,
        0,
        0,
        0
      );
      this.regOriginalDate = this.weddingDate;
      if (this.isLoggedIn) {
        if (!this.analyticsService.skipEuMarketing) {
          this._intercom.boot({ weddingDate: this.weddingDate });
        }
      }
      this.calcDateDiff();



    } else {
      this.weddingDate = null;
    }

    if (!registry.font) {
      registry.font = 'classic';
    }

    if (!registry.imageShape) {
      registry.imageShape = 'arc';
    }
    return registry;
  }

  bag() {
    if (this.isLoggedIn) {
      this.router.navigate(['/registry/bag']);
    } else {
      this.router.navigate([this.registry.registryName + '/bag']);
    }
  }

  populateSectionGifts(statusFilter: string = null) {
    if (this.doNotRefreshGifts) {
      return;
    }
    if (!this.registry || !this.registry.sections || this.registry.sections.length == 0) {
      return;
    }

    if (!this.originalGifts) {
      return
    }
    //this.gifts = this.originalGifts;
    this.sectionGifts = new Array();
    this.registry.sections.forEach(section => {

      if (section) {
        let sectionGifts = new Array<Gift>();

        if (section.giftIds && section.giftIds.length > 0) {


          section.giftIds.forEach(giftId => {
            let giftToAdd = (this.originalGifts.filter(x => x.id == giftId)[0])
            if ((this.featuredGift && giftToAdd && giftToAdd.id != this.featuredGift.id) || !this.featuredGift) {

              if (statusFilter && giftToAdd.status == statusFilter) {
                sectionGifts.push(giftToAdd)
              } else if (!statusFilter) {
                sectionGifts.push(giftToAdd)
              }
            }
          }
          )



        }

        this.sectionGifts.push([section.name, sectionGifts]);
      }
    }



    )

    this.removeGiftsThatExistInSections();




  }


  removeGiftsThatExistInSections() {
    let sectionGifts = new Array<Gift>();
    this.registry.sections.forEach(section => {
      if (this.gifts && this.gifts.length > 0 && section && section.giftIds && section.giftIds.length > 0) {
        let giftsToRemove = this.gifts.filter(gift => section.giftIds.includes(gift.id))
        sectionGifts.push(...giftsToRemove)

      }

    });

    this.gifts = this.gifts.filter(gift => !sectionGifts.includes(gift));
  }


  loadGifts(gifts: Gift[]) {

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {

      if (gifts) {


        this.featuredGift = null;
        gifts.forEach(gift => {
          if (gift.featuredGift && gift.status === 'active') {
            this.featuredGift = gift;




            if (this.featuredGift.portions) {


              this.featuredGiftPortionsRemaining = this.registryService.getPortionsRemaining(this.featuredGift);

            }
            gifts = gifts.filter(x => !x.featuredGift)
          }
        });


        this.availableGifts = gifts.filter(x => x.status === 'active');
        this.soldGifts = gifts.filter(x => x.status === 'paid');

        this.gifts = new Array<Gift>();
        this.gifts = Array.prototype
          .concat(this.availableGifts)
          .concat(this.soldGifts);
        this.sortedGifts = this.gifts;



        this.allGiftsAreGenerated = false;
        if (this.gifts && this.gifts.length && this.gifts.filter(x => x.createdFromGiftAssistant === true).length === this.gifts.length) {
          this.allGiftsAreGenerated = true;
        }


        // if (this.gifts && this.gifts.length == 1) {
        //   this.featuredGift = this.gifts[0];
        //   this.gifts = new Array<Gift>();
        //   this.featuredGiftPortionsRemaining = this.registryService.getPortionsRemaining(this.featuredGift);

        // } else 


        this.populateSectionGifts();


        if (this.featuredGift) {
          this.registryService.setWebsiteUrl(this.featuredGift);
        }


        if (this.registry && this.registry.giftSort) {
          const sortedGifts = new Array<Gift>();
          this.registry.giftSort.forEach(giftId => {
            const sortGift = this.gifts.filter(x => x.id === giftId || (giftId.includes('temp') && x.anonGiftId == giftId))[0];
            if (sortGift) {
              this.gifts = this.gifts.filter(x => x.id !== sortGift.id && x.status == 'active');
              this.sortedGifts = this.gifts;
              if (sortGift.status === "active") {
                sortedGifts.push(sortGift);
              }
            }
          });




          this.gifts = (
            this.gifts.sort(function (a, b) {
              return b.createdDate - a.createdDate;
            })
          ).concat(sortedGifts)
            .concat(this.soldGifts);;
          this.sortedGifts = this.gifts;
        }

        this._cartService.checkCart(this.gifts);

        let totalRegValue = 0;



        let createdGifts = [];
        if (this.gifts && this.gifts.length) {
          createdGifts =
            this.gifts.filter(x => !x.createdFromGiftAssistant)
              .concat(this.gifts.filter(x => x.editedAfterGiftAssistant && x.createdFromGiftAssistant));
          this.sortedGifts = this.gifts;
        }
        this.gifts.forEach(x => {
          if (!x.hidePrice) {
            totalRegValue = totalRegValue + x.price;
          }

        });

        // if (this.isLoggedIn && this.registry) {
        //   this.analyticsService.identifySegmentUserWithRegData(
        //     this.user, this.registry,
        //     this.weddingDate,
        //     this.availableGifts.length,
        //     this.soldGifts.length,
        //     totalRegValue,
        //     createdGifts.length);
        // }
        if (this.isLoggedIn) {
          this.checkSampleGifts();
        }
      }

      if (this.stripeVerify && this.gifts) {

        this.gifts = this.gifts.filter(x =>
          !x.title.toLowerCase().includes('donation') &&
          !x.title.toLowerCase().includes('charity') &&
          !x.title.toLowerCase().includes('donate') &&
          !x.title.toLowerCase().includes('resuce')
        )
        this.sortedGifts = this.gifts;
      }

    }, 300);

  }

  //   if (this.stripeVerify && this.gifts) {
  //     let filterdGifts: Gift[] = new Array<Gift>();
  //     this.gifts.forEach(gift => {

  //       if (!gift.title.toLowerCase().includes('donation') &&
  //         !gift.title.toLowerCase().includes('charity') &&
  //         !gift.title.toLowerCase().includes('donate') &&
  //         !gift.title.toLowerCase().includes('resuce') &&
  //         (gift.description && !gift.description.toLowerCase().includes('resuce') )&&
  //         (gift.description && !gift.description.toLowerCase().includes('charity') )&&
  //         (gift.description && !gift.description.toLowerCase().includes('donate') )&&
  //         (gift.description && !gift.description.toLowerCase().includes('resuce') )
  //       ) {

  // filterdGifts.push(gift);
  //       }
  //     }
  //     )
  // this.gifts = filterdGifts;
  //   }


  // function saveInput(){

  // }
  //const processChange = debounce(() => saveInput());

  updatedTextColour(event) {

    //this.modelChanged.next(event);

    this.textColour = event;
    this.registry.textColour = event;
  }
  updatedBackgroundColour(event) {

    //this.modelChanged.next(event);

    this.backgroundColour = event;
    this.registry.backgroundColour = event;
  }

  createGift() {
    this.router.navigate(['/registry/templates']);
  }
  setColor(event, textColour, backgroundColour) {

    ;

    Array.from(document.querySelectorAll('.color-chips.active')).forEach(function (el) {
      el.classList.remove('active');
    });

    if (event.target.className.includes('chip')) {
      event.target.classList.add('active')
    } else {
      event.target.parentElement.classList.add('active')
    }
    this.textColour = textColour;
    this.registry.backgroundColour = backgroundColour;
    this.registry.textColour = textColour;


    this._registryFirebaseService.saveRegistry(this.registry);

  }
  processContributions() {
    if (this.contributions && this.contributions.length) {



      this.notifications = this.contributions.filter(
        x => x.seen !== true
      ).length;
      this.registryTotal = null;
      this.contributions.forEach(x => {
        this.registryTotal = this.registryTotal + x.giftTotal;
      });
    } else {
      this.registryTotal = 0;
    }
  }

  editText() {
    this.editingWelcome = true;

    //  const introD = document.getElementById("introText");
    // ;
    // this.expandTextArea(intro as HTMLTextAreaElement);
  }

  setTitle() {
    let title = 'Registry | Hitchd';

    if (this.registry && this.registry.firstName && this.registry.partnerFirstName) {

      title = this.registry.firstName + ' and ' + this.registry.partnerFirstName;
      title += ' — Registry on Hitchd'

      // if (this.registry.isOtherRegistry) {
      //   title = this.registry.firstName + ' and ' + this.registry.partnerFirstName + ' on Hitchd';
      // } else if (this.registry.isWeddingRegistry) {
      //   title = title + '\'s Wedding Registry on Hitchd';
      // } else {
      //   title = title + '\'s Honeymoon Registry on Hitchd';
      // }
    }
    ;
    if (this.isLoggedIn) {
      title = 'Hitchd | Registry';
    }

    document.title = title;

  }
  openRecAmountModal() {
    this.showRecAmountModal = true;
  }

  onShowRecommendationChecked(checked: boolean) {

    this.currencySaveButtonEnabled = true;
    this.registry.showRecommendedAmount = checked;

    if (checked) {
      this.registry.defaultGiftPrice = 100;
    } else {
      this.registry.defaultGiftPrice = null;
    }


  }

  cleanBackgroundImageUrl() {
    if (!this.registry) {
      return;
    }
    this.registry.backgroundHeaderImageUrl = this.registryService.cleanImageUrlRemoveHex(this.registry.backgroundHeaderImageUrl);
  }
  clearError() {
    this.wrongPassword = false;
  }

  openCurrencyModal() {
    this.currencySaveButtonEnabled = false;
    this.showCurrencySettings = true;
  }

  setBaseTemplate(registry: Registry) {
    if (registry && registry.isDemo) {
      localStorage.setItem('baseRegistryName', registry.registryName);

    }
  }
  goToSlide1() {
    this.onboardRegistryStep = 1;
    this.onboardingGiftTypeFund = false;
    this.onboardingGiftTypeHoneymoon = false;

    this.analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 1 });
  }
  createSampleGifts() {
    this.allGifts = Array.prototype
      .concat(this.availableGifts)
      .concat(this.soldGifts);
    this._registryFirebaseService.createDefaultGifts(undefined, this.registry, this.allGifts);
    this.analyticsService.trackEvent("Sample gifts created", {});

  }

  copy() {
    window.navigator['clipboard'].writeText('www.hitchd.com?rkq=' + this.registry.userId);
    this.analyticsService.trackEvent('Referral copied', {
      refUrl: 'www.hitchd.com?rkq=' + this.registry.userId
    });
    this.copyLabel = "Copied";
  }

  closeReferal() {
    localStorage.setItem('close-referral', 'true')
    this.closedReferral = true;
    this.analyticsService.trackEvent('Referral header ', {
      refUrl: 'www.hitchd.com?rkq=' + this.registry.userId
    });
  }
  openLink() {
    if (!this.featuredGift.website) {
      return;
    }
    if (this.featuredGift.website.startsWith('http://') || this.featuredGift.website.startsWith('https://')) {
      this.analyticsService.trackEvent('Visit Gift Url', { visit_url: this.featuredGift.website })
      window.open(this.featuredGift.website, '_blank').focus();
    } else {
      this.analyticsService.trackEvent('Visit Gift Url', { visit_url: 'https://' + this.featuredGift.website })
      window.open('https://' + this.featuredGift.website, '_blank').focus();

    }
  }

  checkSampleGifts() {


    this.showSampleGiftButton = false;
    this.allGifts = Array.prototype
      .concat(this.availableGifts)
      .concat(this.soldGifts);
    let result = this._registryFirebaseService.getSampleGifts(this.allGifts, this.registry);
    if (result && result.length) {
      this.showSampleGiftButton = true;
    }


  }

  openPopup(popupType) {

    this.registryService.emitGenricPopup(popupType);
  }

  openLinkOrShowPopup(routerUrl) {
    this.router.navigateByUrl(routerUrl);

  }
  openPreview() {
    this.analyticsService.trackEvent('Registry Open Preview', {});

    if (this.settings && this.website) {
      this.router.navigateByUrl("/" + this.registry.registryName + "/registry" + "?preview=1");
    } else {
      this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
    }
  }

  clearGifts() {

    const gifts = this._registryFirebaseService.gifts;
    if (gifts) {
      gifts.forEach(gift => {
        if (gift.createdFromGiftAssistant) {
          this._registryFirebaseService.removeGift(gift, this.registry);
        }
      });

    }


  }

  processImageBackgroundPosition(registry: Registry) {
    ;
    // this.imageCropString = "20% 20%";
    if (registry.imageRepositionLeft || registry.imageRepositionUp) {
      this.imageCropString = `${registry.imageRepositionLeft == null ? '50' : registry.imageRepositionLeft}% ${registry.imageRepositionUp == null ? '50' : registry.imageRepositionUp}%`
    }

    if (registry.imageRepositionZoom) {
      this.imageZoomString = `scale(${registry.imageRepositionZoom ? registry.imageRepositionZoom : 1})`
    }
  }

  backToRegistry() {
    this.router.navigate(['/registry']);
  }

  openReadOnlyWelcomePopup() {
    if (this.isLoggedIn) {
      this.router.navigate(['/registry/welcome']);
    } else {
      this.router.navigate([this.registry.registryName + '/welcome']);
    }
  }


  checkTrailDays() {
    if (this.registry && this.registry.paid !== undefined && this.registry.paid === false) {
      this.daysLeft = this._registryFirebaseService.trialLeft(this.registry);
      if (this.daysLeft <= 0) {
        // this.router.navigateByUrl('/visibility?expired=true'); remove direct for trial
      }

    }
  }

  configurePassword() {
    if (this.registry && !this.registry.password || location.search.includes('verify')) {
      this.passwordOk = true;
      this.registryService.passwordOk = true;
    }
    if (this.registryService.passwordOk) {
      this.passwordOk = true;
    }
  }


  calculateExpectedReturn(registry: Registry) {
    let exchangeUsdRates = {
      "EUR": 0.941708,
      "JPY": 137.046803,
      "BGN": 1.841793,
      "CZK": 22.847726,
      "DKK": 7.004332,
      "GBP": 0.82148,
      "HUF": 383.369432,
      "PLN": 4.418966,
      "RON": 4.634429,
      "SEK": 10.373199,
      "CHF": 0.930314,
      "ISK": 141.35041,
      "NOK": 9.87221,
      "HRK": 7.099068,
      "RUB": 104.99999999999999,
      "TRY": 18.649496,
      "AUD": 1.494114,
      "BRL": 5.295508,
      "CAD": 1.366042,
      "CNY": 6.972125,
      "HKD": 7.781524,
      "IDR": 15609.256992,
      "ILS": 3.455033,
      "INR": 82.704586,
      "KRW": 1308.691967,
      "MXN": 19.835578,
      "MYR": 4.424522,
      "NZD": 1.571429,
      "PHP": 55.529711,
      "SGD": 1.357284,
      "THB": 34.979753,
      "ZAR": 17.582447,
      "ARS": 75.269373,
      "DZD": 124.445887,
      "MAD": 8.83269,
      "TWD": 27.466513,
      "BTC": 0.000052,
      "ETH": 0.000764,
      "BNB": 0.003633,
      "DOGE": 16.654888,
      "XRP": 2.07083,
      "BCH": 0.008601,
      "LTC": 0.018906
    }



    if (this.registry.guestCount) {

      let exchangeRate: number = 0;
      if (this.registry.currency == 'USD') {
        exchangeRate = 1;
      } else {
        exchangeRate = exchangeUsdRates[this.registry.currency.toUpperCase()]
      }
      this.expectedReturn = exchangeRate * 198 * this.registry.guestCount;
      this.expectedReturn = this.specialRoundUp(this.expectedReturn);

    }



  }




  // updateCurrency() {
  //   //this.country = this.hitchdForm.controls['country'].value;
  //   switch (this.registry.currency) {
  //     case 'AUD': {
  //       this.currency = 'AUD $';
  //       break;
  //     }
  //     case 'USD': {
  //       this.currency = 'USD $';
  //       break;
  //     }
  //     case 'GBP': {
  //       this.currency = 'GBP £';
  //       break;
  //     }
  //     case 'NZD': {
  //       this.currency = 'NZD $';
  //       break;
  //     }
  //     case 'MXN': {
  //       this.currency = 'MXN $';
  //       break;
  //     }
  //     case 'CHF': {
  //       this.currency = 'CHF';
  //       break;
  //     }

  //     case 'JPY': {
  //       this.currency = 'JPY ¥';
  //       break;
  //     }
  //     case 'EUR': {
  //       this.currency = 'EUR €';
  //       break;
  //     }
  //     case 'SGD': {
  //       this.currency = 'SGD $';
  //       break;
  //     }
  //     case 'HKD': {
  //       this.currency = 'HKD $';
  //       break;
  //     }
  //     case 'CAD': {
  //       this.currency = 'CAD $';
  //       break;
  //     }
  //     case 'DKK': {
  //       this.currency = 'DKK Kr';
  //       break;
  //     }
  //     case 'SEK': {
  //       this.currency = 'Kr';
  //       break;
  //     }
  //     case 'NOK': {
  //       this.currency = 'Kr';
  //       break;
  //     }
  //   }
  // }

  setCurrency() {
    switch (this.registry.country) {
      case 'AU': {
        this.registry.currency = 'AUD';
        break;
      }
      case 'MX': {
        this.registry.currency = 'MXN';
        break;
      }
      case 'US': {
        this.registry.currency = 'USD';
        break;
      }
      case 'GB': {
        this.registry.currency = 'GBP';
        break;
      }
      case 'DK': {
        this.registry.currency = 'DKK';
        break;
      }
      case 'NZ': {
        this.registry.currency = 'NZD';
        break;
      }

      case 'JP': {
        this.registry.currency = 'JPY';
        break;
      }

      case 'CA': {
        this.registry.currency = 'CAD';
        break;
      }
      case 'AT': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'BE': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'EE': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'FI': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'FR': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'DE': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'GR': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'IE': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'IT': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'LV': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'LT': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'LU': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'NL': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'PT': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'MX': {
        this.registry.currency = 'MXN';
        break;
      }
      case 'SK': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'SI': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'ES': {
        this.registry.currency = 'EUR';
        break;
      }
      case 'SG': {
        this.registry.currency = 'SGD';
        break;
      }
      case 'SG': {
        this.registry.currency = 'USD';
        break;
      }
      case 'HK': {
        this.registry.currency = 'HKD';
        break;
      }
      case 'SE': {
        this.registry.currency = 'SEK';
        break;
      }
      case 'NO': {
        this.registry.currency = 'NOK';
        break;
      }
      case 'CH': {
        this.registry.currency = 'CHF';
        break;
      }
      case 'JP': {
        this.registry.currency = 'EUR';
        break;
      }
    }
    this.currencySaveButtonEnabled = true;


  }

  specialRoundUp(num) {
    var factor = Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
    return factor * Math.ceil(num / factor);
  }


  defaultTextColor() {
    if (!this.registry.textColour) {
      // this.registry.textColour = "#fff";
    }
  }

  init() {
    this.debugTimer("init - begin")


    this.registry = this.route.snapshot.data.registry;
    this.website = this.route.snapshot.data.website;
    this.checkPreviousPW();
    this._registryFirebaseService.killLoader();
    this.initRegistryData();



    if (location.search.includes('preview')) {
      this.preview = true;
      if (this._cdr && !this._cdr['destroyed']) {
        this._cdr.detectChanges();
      }
    }

    this.backgroundHeaderImageColor = this.registry.backgroundColour;
    this.textColour = this.registry.textColour;



    this.calculateExpectedReturn(this.registry);
    this._registryFirebaseService.cleanXssFromRegistry(this.registry);
    this.canSeeLoops = this.registry && (!this.registry.paid || this.registry.tier != 'small')
    this.contributionLimit = this._registryFirebaseService.getContributionLimit(this.registry);
    this.calculatePercent();

    if (this.registry) {
      this.checkTrailDays();
      let dismissRegSetupPopup = localStorage.getItem("completed_reg_setup");

      // if (this.registry.firstName == "You" && !dismissRegSetupPopup) {
      //   this.registryService.emitGenricPopup("setup");
      // }

      this.setBaseTemplate(this.registry);

      this.configurePassword();
      this.cleanBackgroundImageUrl();
      this.hideGuestBanner = this.registryService.hideGuestBanner;
      this.setTitle();
      this.isLoggedIn = this.route.snapshot.data.isLoggedIn;
      this.user = this.route.snapshot.data.user;
      this.contributions = this.route.snapshot.data.contributions;


      if (this.isLoggedIn) {
        this._registryFirebaseService.registryForUser(this.user).subscribe((reg) => {
          this.registry = reg;
          this.checkPaymentMethods();
          this.loadDates(this.registry);
          this.initRegistryData();
          this.loaded = true;
          //  this.loadGifts(this.originalGifts);
        })
      }

      if (this.isLoggedIn && this.showTranslation && !this.preview) {
        this.showTranslation = false;
      }



      const routeGifts: Gift[] = this.route.snapshot.data.gifts;


      if ((!routeGifts || routeGifts.length == 0) && !dismissRegSetupPopup) {
        this.showRegOnboarding = true;
      } else {
        this.showRegOnboarding = false;
      }

      this.originalGifts = routeGifts;

      if (this.registry && this.registry.registryName) {
        this._registryFirebaseService.registryByName(this.registry.registryName)
          .takeUntil(this.ngUnsubscribe)
          .subscribe(reg => {

            this.registry = reg;

            this.initRegistryData();
            // this.loadGifts(this.originalGifts)
            this._registryFirebaseService.cleanXssFromRegistry(this.registry);

            if (this.registry && this.registry.isLive && !this.registry.paid && !this.preview && !this.isLoggedIn) {
              //route to coming-soon without updating the url              
              this.router.navigate(['/coming-soon'], { skipLocationChange: true });

            }

            this.loaded = true;


          });
      }
      ;
      if (this.isLoggedIn) {



        this._authService.user.take(1).subscribe(user => {


          this.user = user;
          if (this.user) {

            this._registryFirebaseService.transferLocalGiftsToFirebase(undefined, this.registry);

            this.isLoggedIn = true;
          }
          this._settingsStateStore.getState().subscribe(state => {
            if (state && state.settings) {
              this.settings = state.settings;
              this.checkPaymentMethods();
            }

          });
          if (!this._intercom.visitorId) {
            if (!this.analyticsService.skipEuMarketing) {
              this._intercom.boot({ email: this.user.email });
              this._intercom.update({ name: this.registry.firstName });
            }
          }
        });

      } else if (this.registry && this.user && this.registry.userId === this.user.userId && (location.search.includes('preview'))) {
        // this.router.navigate(["coming-soon"]);
        this.preview = true;
        this.passwordOk = true;
        this.registryService.passwordOk = true;
        this.registryService.setPreview(true);
        this.isLoggedIn = false;

      } else if ((this.registry && location.search.includes('verify'))) {

        if (location.search.includes('verify')) {
          this.stripeVerify = true;
        }
      }
      else if (this.registry && !this.registry.isLive && !location.search.includes('preview')) {

        this.router.navigate(['coming-soon']);
      } else if (this.registry && location.search.includes('preview')) {
        this.preview = true;

      }


      this.loadGifts(routeGifts);
      if (this.registry && this.registry.id) {
        this._registryFirebaseService
          .getGiftsforRegistry(this.registry.id)
          .subscribe(gifts => {

            this.originalGifts = gifts;
            this.checkSampleGifts();
            if (gifts) {
              this.loadGifts(gifts);
              this.populateSectionGifts();

            }
          });
      }



      this.registry = this.loadDates(this.registry);
      this.initRegistryData();
      this._registryFirebaseService.cleanXssFromRegistry(this.registry);
      if (this.isLoggedIn) {

        this._registryFirebaseService.currentRegistry.subscribe(reg => {

          if (reg) {
            this.registry = reg;

            this.initRegistryData();
            this.loadDates(this.registry);
            //  this.populateSectionGifts();
          }
        })
        this._registryFirebaseService
          .registryForUser(this.user)
          .takeUntil(this.ngUnsubscribe)
          .subscribe(reg => {

            if (reg) {
              this.registry = reg;

              this.populateSectionGifts();
              this.initRegistryData();
              this._registryFirebaseService.cleanXssFromRegistry(this.registry);
              this.calculatePercent();
              this.cleanBackgroundImageUrl();

            }
          });


        this._registryFirebaseService
          .getContributions(this.gifts)
          .takeUntil(this.ngUnsubscribe)
          .subscribe(contributions => {

            this.contributions = contributions;
            this.processContributions();
          });
      }

      this.registryService.headerTypeEmitted$.subscribe(x => {

        this.registry.backgroundHeaderImageUrl = this.registryService.cleanImageUrlRemoveHex(
          x
        );
        this.backgroundHeaderImageColor = this.registryService.getColor(x);
        this.showHeaderImageSelectorModal = false;
      });

      this.registryService.headerPopupClose$
        .takeUntil(this.ngUnsubscribe)
        .subscribe(x => {
          this.cdRef.detectChanges();
          this.showHeaderImageSelectorModal = false;
        });

      this.userService.CleanUrlAfterSignin();

      const element = document.querySelector('body');
      //  element.setAttribute('class', '');

      this.route.data.subscribe(data => {
        this.headerType = data['header'] as string;
        this.userService.emitUpdateHeaderType('registry');
      });
    }

    this._websiteStateStore.getState().subscribe(state => {
      if (state && state.website) {
        this.website = state.website;
      }
    })
    this.debugTimer("end - begin")
  }

  public setImageShape(shape) {
    this.registry.imageShape = shape;
    this._registryFirebaseService.saveRegistry(this.registry);
    this.showScrollBar();
  }

  duplicateGift(gift: Gift) {
    this._registryFirebaseService.duplicateGift(gift, this.gifts, this.registry, this.router);
    this.analyticsService.trackEvent("Gift duplicated", { title: gift.title });
  }

  openMobileMenu() {
    this.userService.emitUpdateHeaderType('showMobileMenu');
  }


  handleGiftDeleted(giftId: string) {

    this.stopAutoScroll = true;

    this.checkSampleGifts();
    this.populateSectionGifts();
  }

  handleMoveModalEvent(event: Gift) {

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    this.movingGift = event;
    this.movingGiftIsInMyGifts = false;
    this.movingGiftExistsInSectionName = null;
    this.registry.sections.forEach(section => {
      if (section.giftIds && section.giftIds.includes(this.movingGift.id)) {
        this.movingGiftExistsInSectionName = section.name;
      }

    }


    )


    if (!this.movingGiftExistsInSectionName) {
      this.movingGiftIsInMyGifts = true;
    }
    this.isMovingGiftToSection = true;


  }

  handleHeaderSelectorPopup(event: any) {
    if (event === 'close') {
      this.showHeaderImageSelectorModal = false;
    }
  }
  showPopup() {
    // window.scrollTo(0, 0);
    this.editingWelcome = false;
    this.showHeaderImageSelectorModal = true;
    this.analyticsService.trackEvent('browsing background images', null);
    this.registryService.emitShowHeaderUpdated();
  }

  close() {
    // this.bagSize = -1;
  }


  selectGift(gift: Gift, event?: Event) {


    // if (event) {
    //   event.stopPropagation();
    //   return;
    // }
  
    if (this.selectedGiftIsForBulkDelete && this.selectedGiftIsForBulkDelete.size > 0) {
      this.registryService.setScrollY(window.scrollY);
      this.toggleGiftBulkDeleteCheckBox(gift, event);
      return;
    }
    //this.stopAutoScroll = true;
    if (gift.removing) {
      return;
    }

    if (this.selectedGiftCount > 1) {
      gift.removing = true;
      return;
    }


    if (
      gift.paidPercent >= 100 && this.isLoggedIn && this.user && this.user.userId) {
      this.router.navigateByUrl(window.location.pathname + '/' + gift.friendlyUrl.toLowerCase() + "?preview=1&fundedgift=1"
      );
      return;
    }



    const giftSelection = new GiftSelection();
    giftSelection.gift = gift;
    this.registryService.setGiftSelection(giftSelection);
    //

    this.registryService.setScrollY(window.scrollY);
    if (this.isLoggedIn) {
      this.router.navigate([
        window.location.pathname + '/' + giftSelection.gift.friendlyUrl.toLowerCase() + '/edit'
      ]);
    } else {
      this.router.navigate([
        window.location.pathname + '/' +
        giftSelection.gift.friendlyUrl.toLowerCase()
      ]);
    }
  }

  setRegistryToLive() {
    if (!this.registry.isLive) {
      // Set registry to public
      this.registry.isLive = true;

      // Save the registry
      this._registryFirebaseService.saveRegistry(this.registry).then(() => {
        // Show success message
        this.registryService.emitGenericToastMsg("Your registry is now public");
      });
    }
  }

  private checkCssLoaded() {
    const MAX_RETRIES = 10; // Reduced from 20 to 10
    const RETRY_INTERVAL = 50; // Reduced from 100ms to 50ms
    let retries = 0;

    const check = () => {
      // Look for stylesheets that contain our marker class
      const styleSheets = Array.from(document.styleSheets).filter(sheet => {
        try {
          const rules = Array.from((sheet as CSSStyleSheet).cssRules || []);
          return rules.some(rule => {
            if (rule instanceof CSSStyleRule) {

              const hasMatch = rule.selectorText ? rule.selectorText.includes('registry-styles-loaded') : false;
              if (hasMatch) {

              }
              return hasMatch;
            }
            return false;
          });
        } catch (e) {
          return false;
        }
      });

      // Check if at least one relevant stylesheet is loaded with rules
      const mainStylesLoaded = styleSheets.length > 0 && styleSheets.some(sheet => {
        try {
          return (sheet as CSSStyleSheet).cssRules !== null &&
            (sheet as CSSStyleSheet).cssRules.length > 0;
        } catch (e) {
          return false;
        }
      });

      if (mainStylesLoaded) {
        this.cssLoaded = true;
      } else if (retries < MAX_RETRIES) {
        retries++;
        setTimeout(check, RETRY_INTERVAL);
      } else {
        console.warn('CSS loading timeout - forcing display');
        this.cssLoaded = true;
      }
    };

    // Start checking after a brief initial delay
    setTimeout(check, 10);
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as Element;
    this.isDropdownOpen = false;
  }

  openDropdown(event: Event) {
    event.stopPropagation();
    
    if(this.selectedDestinations.length >= 3){
      return;
    }

    this.isDropdownOpen = true;
    // Show all destinations initially
    this.filteredCountries = [...this.destinationCountries];
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }

  // onSearchInput(event: Event) {
  //   const searchText = (event.target as HTMLInputElement).value.toLowerCase();
  //   if (!searchText) {
  //     // Show all destinations when search is empty
  //     this.filteredCountries = [...this.destinationCountries];
  //   } else {
  //     this.filteredCountries = this.destinationCountries.filter(country =>
  //       country.toLowerCase().includes(searchText)
  //     );
  //   }
  // }

  selectCountry(country: string, event?: Event) {
    // Stop event propagation if event exists
    if (event) {
      event.stopPropagation();
    }

    this.listSelectedCountries = country;
    this.isDropdownOpen = false;
    this.searchText = '';
  }



  addCustomDestination(destination: string, event?: Event) {
    // Stop event propagation if event exists
    if (event) {
      event.stopPropagation();
    }

    if (!this.customDestinations) {
      this.customDestinations = [];
    }
    if (this.selectedDestinations.includes(destination)) {
      this.customDestinations.splice(this.customDestinations.indexOf(destination), 1);
      this.selectedDestinations.splice(this.selectedDestinations.indexOf(destination), 1);
    } else {
      this.customDestinations.push(destination);
      this.selectedDestinations.push(destination);
    }
    this.collaceSelectedCountries();
    this.isDropdownOpen = false;
    this.searchText = '';
    // Add any additional logic for handling custom destinations
  }

  // Add this method to get destinations for a country
  getPopularDestinations(countryCode: string): string[] {
    return this.popularDestinations[countryCode] || this.popularDestinations["DEFAULT"];
  }


  getCountry(country: string) {
    switch (country) {
      case 'AU': {
        return 'Australia';
      }
      case 'GB': {
        return 'UK';
      }
      case 'US': {
        return 'United States';
      }
      case 'NZ': {
        return 'New Zealand';
      }
      case 'JP': {
        return 'Japan';
      }
      case 'CA': {
        return 'Canada';
      }
      case 'AT': {
        return 'Austria';
      }
      case 'BE': {
        return 'Belgium';
      }
      case 'EE': {
        return 'Estonia';
      }
      case 'FI': {
        return 'Finland,';
      }
      case 'FR': {
        return 'France';
      }
      case 'DE': {
        return 'Germany,';
      }
      case 'DK': {
        return 'Denmark';
      }
      case 'GR': {
        return 'Greece';
      }
      case 'IE': {
        return 'Ireland';
      }
      case 'IT': {
        return 'Italy';
      }
      case 'LV': {
        return 'Latvia';
      }
      case 'LT': {
        return 'Lithuania';
      }
      case 'LU': {
        return 'Luxembourg';
      }
      case 'MX': {
        return 'Mexico';
      }
      case 'NL': {
        return 'Netherlands';
      }
      case 'PT': {
        return 'Portugal';
      }
      case 'SK': {
        return 'Slovakia';
      }
      case 'SI': {
        return 'Slovenia';
      }
      case 'ES': {
        return 'Spain';
      }
      case 'SG': {
        return 'Singapore';
      }
      case 'HK': {
        return 'Hong Kong';
      }
      case 'NO': {
        return 'Norway';
      }
      case 'CH': {
        return 'Switzerland';
      }
      case 'SE': {
        return 'Sweden';
      }
    }
    this.setCurrency();
  }

  // Add these properties
  placeSuggestions: Array<{ location: string, text: string }> = [];
  isLoading = false;
  private searchDebounce: any;

  // Update the onSearchInput method
  async onSearchInput(event: any) {
    const query = event.target.value;
    this.searchText = query;

    // Clear previous timeout
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }

    // Only search if we have 3 or more characters
    if (query && query.length >= 2) {
      this.isLoading = true;

      // Debounce the API call
      this.searchDebounce = setTimeout(async () => {
        try {
          const response = await fetch(`${environment.firebase.clouldFunctionHost}/getPlaceSuggestions?query=${encodeURIComponent(query)}`);
          if (!response.ok) {
            throw new Error('Failed to fetch suggestions');
          }
          this.placeSuggestions = await response.json();
        } catch (error) {
          console.error('Error fetching place suggestions:', error);


          this.placeSuggestions = [];
        } finally {
          this.isLoading = false;
        }
      }, 300); // Wait 300ms after user stops typing
    } else {
      this.placeSuggestions = [];
    }
  }

  // Add method to select a suggestion
  selectSuggestion(suggestion: { location: string, text: string }, event: Event) {
    event.stopPropagation();
    this.addCustomDestination(suggestion.text, event);
    this.searchText = '';
    this.analyticsService.trackEvent('Registry Onboarding - Destinations - Add Destination', { destination: suggestion.text, from:'suggestions-dropdown' });
    this.placeSuggestions = [];
  }

  // Add these properties
  isCreatingGifts = false;
  currentLoadingMessage = '';
  private loadingMessages = [
    "Gathering gift suggestions...",
    "Searching for perfect images...",
    "Populating titles and descriptions...",
    "Creating your unique gifts...",
    "Sprinkling delight...",
    "Adding final touches...",
    "Wrapping it up..."
  ];
  private messageInterval: any;

  // Add these methods to handle loading sequence
  private startLoadingSequence() {
    let messageIndex = 0;
    this.currentLoadingMessage = this.loadingMessages[0];

    this.messageInterval = setInterval(() => {
      messageIndex = (messageIndex + 1) % this.loadingMessages.length;
      this.currentLoadingMessage = this.loadingMessages[messageIndex];
    }, 3000); // Change message every 3 seconds
  }

  private stopLoadingSequence() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
      this.messageInterval = null;
    }
  }


  toggleGiftBulkDeleteCheckBox(gift: Gift, event: Event) {

    if (this.selectedGiftIsForBulkDelete.has(gift.id)) {
      this.selectedGiftIsForBulkDelete.delete(gift.id);
      gift.selected = false;
    } else {
      this.selectedGiftIsForBulkDelete.add(gift.id);
      gift.selected = true;
    }

    if (this.selectedGiftIsForBulkDelete.size){
      this.oneOrMoreGiftSelectedForDelete = true;
    } else {
      this.oneOrMoreGiftSelectedForDelete = false;
    }

    if (event) {
      event.stopPropagation();
      return;
    }

  }

  isGiftSelectedForBulkDelete(gift: Gift): boolean {
    console.log('isGiftSelectedForBulkDelete', gift.id);
    return this.selectedGiftIsForBulkDelete.has(gift.id);
  }

  trackByGiftId(index: number, gift: Gift): string {
    if (!gift) {
      return '';
    }
    return gift.id;
  }


  get hasAnyGiftDeleting(): boolean {
    if (!this.allGifts) {
      return false;
    }
    return this.selectedGiftIsForBulkDelete.size > 0;
  }

  get selectedGiftCount(): number {
    if (!this.allGifts) {
      return 0;
    }

    return this.selectedGiftIsForBulkDelete.size;
  }

  async resetOnboardingForTesting() {
    this.settings.completedRegistryOnboarding = false;
    await this._settingsStateStore.updateSettings(this.settings);
  }

  async deleteSelectedGifts() {
    const giftsToDelete = this.allGifts.filter(gift => this.selectedGiftIsForBulkDelete.has(gift.id));

    const totalGifts = this.allGifts.length;
    const expectedRemainingGifts = totalGifts - giftsToDelete.length;

    if (this.featuredGift && this.selectedGiftIsForBulkDelete.has(this.featuredGift.id)) {
      giftsToDelete.push(this.featuredGift);
    }
    try {
      // Show loading state with overlay
      this.isDeletingBulkGifts = true;
      this.currentLoadingMessage = `Deleting ${giftsToDelete.length} gifts...`;
      this.startLoadingSequence();

      // Delete each gift
      for (const gift of giftsToDelete) {
        await this._registryFirebaseService.removeGift(gift, this.registry);
      }

      // Wait for gifts count to update
      const giftsUpdated = await this.waitForGiftsExactNumber(10, expectedRemainingGifts);
      if (!giftsUpdated) {
        console.warn('Gift count did not update as expected');
      }

      // Cleanup
      this.stopLoadingSequence();
      this.isDeletingBulkGifts = false;
      this.selectedGiftIsForBulkDelete.clear();
      // Show success message
      this.registryService.emitGenericToastMsg(
        `Successfully deleted ${giftsToDelete.length} gifts`
      );

    } catch (error) {
      console.error('Error deleting gifts:', error);
      this.stopLoadingSequence();
      this.isDeletingBulkGifts = false;
      this.registryService.emitGenericToastMsg("Error deleting gifts");
    }
  }

  // Add this helper method to the class
  private async waitForGifts(maxAttempts = 10, waitForHowManyGifts = 1): Promise<boolean> {
    for (let i = 0; i < maxAttempts; i++) {
      
      if (this.allGifts && this.allGifts.length >= waitForHowManyGifts) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 500ms between checks
    }
    return false;
  }
  private async waitForGiftsExactNumber(maxAttempts = 10, waitForHowManyGifts = 1): Promise<boolean> {
    for (let i = 0; i < maxAttempts; i++) {
      if (this.allGifts && this.allGifts.length == waitForHowManyGifts) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 500ms between checks
    }
    return false;
  }

  getStandardImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }

  getHeroImageUrl(imageUrl: string): string {
    return this.imageUrlService.getHeroImageUrl(imageUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/registry/registry.component.ts